// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:14:32.329Z
// Property: The Park Avenue Lofts (ID: 6737460151192619)
// Collections: 52 amenities, 12 floorplans (live), 79 photos, 72 POIs, 5 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192619",
  "property_external_id": "4562637",
  "property_zillow_url": "https://www.zillow.com/apartments/little-rock-ar/park-avenue-lofts/5Xyn4M/",
  "property_apartments_url": "https://www.apartments.com/park-avenue-lofts-little-rock-ar/286kh3b",
  "property_google_business_url": "https://www.google.com/maps/place/Park+Avenue+Lofts/data=!4m2!3m1!1s0x0:0xb080287573628f10?sa=X&ved=2ahUKEwjL9dbWwrySAxV-yckDHQ8ZLzAQ_BJ6BAgQEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "2756511724",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-park-avenue-lofts",
  "property_name": "The Park Avenue Lofts",
  "property_website_url": "https://www.theparkavenuelofts.com/",
  "property_domain": "https://www.theparkavenuelofts.com/",
  "property_address": "320 S University Ave",
  "property_full_address": "320 S University Ave, Little Rock, AR 72205",
  "property_address_1": "320 S University Ave",
  "property_address_2": null,
  "property_address_city": "Little Rock",
  "property_address_state": "AR",
  "property_address_zip_full": "72205-5209",
  "property_address_zip": "72205",
  "property_address_country": "US",
  "property_address_county": "Pulaski County",
  "property_neighborhood_address": "Briarwood",
  "property_address_latitude": "34.7502416",
  "property_address_longitude": "-92.34343849999999",
  "property_email": "parkavenuelofts@rreafresidential.com",
  "property_phone": "(501) 663-7275",
  "property_call_tracking_phone": "501-298-4483",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At The Park Avenue Lofts in Little Rock, AR, experience modern living with diverse floor plans including studios and two-bedroom layouts. Enjoy premium amenities like a cozy gas fire pit, a flourishing Starbucks WiFi café, and convenient 24/7 maintenance. Your vibrant new lifestyle awaits—schedule a tour today!",
  "property_long_description": "Welcome to The Park Avenue Lofts, where contemporary living meets unparalleled comfort in the heart of Little Rock, AR. Our thoughtfully designed apartment community offers a variety of floor plans, including spacious studios, elegant one-bedroom flats, and expansive two-bedroom layouts, ensuring that you'll find the perfect space to call home. \n\nExperience a wealth of exceptional amenities tailored to enhance your lifestyle. Gather with friends around our gas grills or unwind by the gas fire pit in our beautifully landscaped surroundings. For those who love to work in style, our Starbucks WiFi Cafe & Lounge provides the perfect setting for productivity. Our commitment to sustainability shines through our recycling program, making it easier for you to live green.\n\nAt The Park Avenue Lofts, we prioritize your convenience with 24-hour on-call maintenance and management services. Our fully-equipped clothes care center features flexible payment options, while select models offer in-unit full-size washers and dryers. Enjoy the luxury of private balconies, spacious townhome layouts, and stunning pool views. \n\nSchedule a tour today to experience our vibrant community and see why The Park Avenue Lofts is the ideal choice for your new home. Don’t miss out on this opportunity—browse our availability online or call us to set up your visit! Find your new home today and embrace a life of luxury and convenience at The Park Avenue Lofts!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-44d9-744c-b383-09415245251e.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior view of a modern apartment building at dusk with a red accent wall and balconies.",
    "public_id": "019e69a5-44d9-744c-b383-09415245251e",
    "storage_key": "property/6737460151192619/019e69a5-44d9-744c-b383-09415245251e.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "258",
  "property_year_built": "2013",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.7984496124031",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "400",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>Breed restrictions apply at this community. Please inquire with the office. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://theparkavenuelofts.loftliving.com/login",
  "property_apply_now_url": "https://8022317.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-7bee-7169-a3d8-8c689a939c36.webp",
  "property_primary_logo_media": {
    "alt_text": "Park Avenue Lofts logo",
    "public_id": "019e1e09-7bee-7169-a3d8-8c689a939c36",
    "storage_key": "property/6737460151192619/019e1e09-7bee-7169-a3d8-8c689a939c36.webp",
    "width": 273,
    "height": 150
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-7b95-7117-ac86-ea1561b3f5a3.webp",
  "property_secondary_logo_media": {
    "alt_text": "Park Avenue Lofts logo",
    "public_id": "019e1e09-7b95-7117-ac86-ea1561b3f5a3",
    "storage_key": "property/6737460151192619/019e1e09-7b95-7117-ac86-ea1561b3f5a3.webp",
    "width": 273,
    "height": 150
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-7b95-7117-ac86-ea1561b3f5a3.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Park Avenue Lofts logo",
    "public_id": "019e1e09-7b95-7117-ac86-ea1561b3f5a3",
    "storage_key": "property/6737460151192619/019e1e09-7b95-7117-ac86-ea1561b3f5a3.webp",
    "width": 273,
    "height": 150
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e8e87-4073-77d9-be6f-24dd8048074a.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-4073-77d9-be6f-24dd8048074a",
    "storage_key": "property/6737460151192619/019e8e87-4073-77d9-be6f-24dd8048074a.webp",
    "width": 273,
    "height": 150
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d345e",
  "property_secondary_color": "#eae9e1",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "582 - 1544",
  "property_sqft_min": "582",
  "property_sqft_max": "1544",
  "property_price_range": "1050 - 2145",
  "property_price_min": "1050",
  "property_price_max": "2145",
  "property_available_units": 16,
  "property_facebook_url": "https://www.facebook.com/people/Park-Avenue-Lofts/61554639034810/",
  "property_instagram_url": "https://www.instagram.com/Park_Avenue_Lofts",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJzbMHcoCk0ocREI9ic3UogLA",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/park-avenue-lofts-by-pegasus-residential-little-rock",
  "property_tiktok_url": "https://www.tiktok.com/@park.avenue.lofts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Park Avenue Lofts",
  "property_home_romance_title": "Experience Love at First Sight in Your New Apartment",
  "property_home_amenities_blurb": "<p>Park Avenue Lofts is located in Little Rock’s highly anticipated lifestyle center, Park Avenue. The center is <a href=\"/floor-plans/\">home</a> to an emerging collection of eateries, shops and offices – all at your fingertips. And with Midtowne Little Rock and Park Plaza Mall a short walk away, and downtown’s River Market a short drive away, you are always within minutes of indulging in the city’s finest offerings. All work, no play? No problem. Park Avenue Lofts is located in the heart of the midtown corridor, across the street from <a href=\"https://www.chistvincent.com/\">St. Vincent Health System</a> and minutes from both the <a href=\"https://www.uams.edu/\">University of Arkansas for Medical Sciences</a> and University of Arkansas at Little Rock campuses. However you script your world, Park Avenue Lofts is the perfect place to live, work and play in a unique urban oasis.</p>",
  "property_home_floorplans_blurb": "<p>Ideally located in Little Rock, AR, the neighborhood surrounding Park Avenue Lofts has so much to offer. Entertainment, restaurants, schools, & services combine to create a conveniently placed home. Apartments by UAMS Medical Center, CHI ST. Vincent Infirmary, John L. McClellan Memorial Veterans' Hospital, Baptist Health Medical Center, and Arkansas Children's Hospital.</p>",
  "property_home_gallery_blurb": "At The Park Avenue Lofts in Little Rock, AR, modern living meets comfort in our versatile studio, one-, and two-bedroom apartments. Enjoy enticing amenities like a refreshing pool, a state-of-the-art fitness center, and planned social events. Picture yourself relaxing in a cabana or dining al fresco with friends!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Little Rock, The Park Avenue Lofts offers stylish floor plans, including studios, one, and two-bedroom apartments. Immerse yourself in vibrant local culture—delight in nearby cafes, parks, and shopping. Ready to experience the neighborhood? Discover the hidden gems surrounding our community!",
  "property_home_reviews_blurb": "At The Park Avenue Lofts in Little Rock, every detail, from spacious floor plans to a stylish clubhouse, creates a welcoming atmosphere. Residents appreciate the close-knit community and helpful staff, like Heather, who make moving a breeze. Enjoy resort-style amenities while living just steps away from shopping and dining.",
  "property_neighborhood_blurb": "<p>Ideally located in Little Rock, AR, the neighborhood surrounding Park Avenue Lofts has so much to offer. Entertainment, restaurants, schools, & services combine to create a conveniently placed home. Apartments by UAMS Medical Center, CHI ST. Vincent Infirmary, John L. McClellan Memorial Veterans' Hospital, Baptist Health Medical Center, and Arkansas Children's Hospital.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>At Park Avenue Lofts, you'll experience an easy lifestyle with our exceptional on-site amenities. Enjoy the convenience of our 24-hour fitness center, gas fire pit, & resort-style pool with beach entry right outside your door.</p>",
  "property_applynow_blurb": "Elevate your lifestyle at The Park Avenue Lofts in Little Rock, AR. Choose from stylish studio, one, or two-bedroom layouts, each tailored for modern living. Enjoy resort-style amenities like gas grills, a Starbucks WiFi lounge, and 24/7 maintenance. Your perfect home awaits—lease online today and embrace luxury living!",
  "property_contactus_blurb": "At The Park Avenue Lofts in Little Rock, AR, you'll find a perfect space tailored to your lifestyle—whether it’s a cozy studio or a spacious two-bedroom. Our flexible floor plans cater to your every need. Have questions? Contact our leasing team today and let us help you find your ideal home!",
  "property_faqs_blurb": "At The Park Avenue Lofts in Little Rock, AR, your perfect space awaits—from chic studios to spacious two-bedroom layouts. Curious about our community? Visit our FAQs page for insights into amenities, leasing, and more. Your ideal urban lifestyle starts here!",
  "property_floorplans_blurb": "<p>Find the perfect layout for you! Our one and two bedroom apartments come with various interior <a href=\"/amenities/\">features</a> to make you feel right at home. Our floor plans include a balcony* and pool view. Home has never felt quite like this - browse our floor plans below!</p>\n<p>*in select apartment homes, call our office for more details</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "At The Park Avenue Lofts in Little Rock, AR, our diverse floor plans—ranging from cozy studios to spacious two-bedroom apartments—cater to your unique lifestyle. Enjoy modern amenities like gas grills, a Starbucks WiFi café, and 24/7 management for effortless living. Dive into our interactive community map to find your perfect home!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>Breed restrictions apply at this community. Please inquire with the office. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At The Park Avenue Lofts in vibrant Little Rock, AR, embrace stylish living in our diverse floor plans, from cozy studios to spacious two-bedrooms. Great friends make great neighbors—refer a friend and share the joy of this unique community. Connect and thrive together in your new home today!",
  "property_residentaccess_blurb": "At The Park Avenue Lofts in Little Rock, AR, choose from stylish studio, one-bedroom, or two-bedroom floor plans designed for modern living. Easily manage your residency through our portal—pay rent, schedule maintenance, and connect with your community effortlessly. Dive into convenience and comfort at your fingertips!",
  "property_reviews_blurb": "Experience the vibrant spirit of urban living at Park Avenue Lofts in Little Rock, AR, where residents rave about the \"modern feel\" and \"hassle-free\" move-in experience. Enjoy exceptional amenities, welcoming staff, and a community atmosphere that makes it easy to call this place home. Join us and see what the excitement is all about!",
  "property_created_at": "1752257250687",
  "property_scheduletour_blurb": "At The Park Avenue Lofts in vibrant Little Rock, AR, your ideal living space awaits. Choose from chic studios, spacious one-bedroom, or stylish two-bedroom floor plans tailored to your lifestyle. Schedule a tour today and hear firsthand from our happy residents about their enriching community experience!",
  "property_thankyou_blurb": "Thank you for reaching out to The Park Avenue Lofts in vibrant Little Rock, AR! With stylish studio, one-bedroom, and two-bedroom floor plans tailored for modern living, we’re excited to help you find your perfect home. A team member will be in touch soon to assist you further!",
  "property_virtualtours_blurb": "<p>Virtual tours are available at Park Avenue Lofts in Little Rock, AR. Take a virtual tour of a 1 and 2-bedroom apartment and find your next home today!</p>",
  "property_copyright": "2025 All Rights Reserved. The Park Avenue Lofts",
  "property_seo_title_home": "The Park Avenue Lofts | Apartments in Little Rock, AR",
  "property_seo_description_home": "Elevate your lifestyle at The Park Avenue Lofts in Little Rock, AR, where modern living meets eco-friendly amenities! Choose from our stylish studio, one-, and two-bedroom floor plans and enjoy perks like a Starbucks WiFi café, gas fire pits, and expansive balconies. With 24/7 management and maintenance, plus on-site laundry options, convenience is key. Experience a community that cares—find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | studio - 2 Apartments in Little Rock, AR",
  "property_seo_description_floorplans": "Unveil your ideal living space at The Park Avenue Lofts in vibrant Little Rock, AR. With versatile studio, one-bedroom, and two-bedroom floor plans, each apartment is designed for comfort and style. Whether you crave a cozy studio or need more space for your family, browse our stunning options and redefine your lifestyle today!",
  "property_seo_title_amenities": "Amenities | Little Rock, AR Apartments for Rent",
  "property_seo_description_amenities": "Unwind at The Park Avenue Lofts in Little Rock, AR, where comfort meets style. From cozy studios to spacious two-bedroom homes, each floor plan is designed for modern living. Enjoy resort-like amenities, including gas grills, a Starbucks WiFi café, and a relaxing gas fire pit. With 24/7 management and maintenance at your service, your peace of mind is our priority. Whether you prefer a private balcony or a lush yard, our community has something for everyone. Dive into unparalleled living—your new home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Little Rock, AR",
  "property_seo_description_gallery": "\"Immerse yourself in the vibrant lifestyle at The Park Avenue Lofts in Little Rock, AR. With versatile floor plans including studio, one, and two-bedroom options, and amenities like a cozy Starbucks WiFi Cafe, gas grills, and 24/7 maintenance, life here is both comfortable and convenient. Picture your mornings spent at the pool view balcony or evenings by the gas fire pit—your perfect new home awaits in our stunning photo gallery!\"",
  "property_seo_title_virtualtours": "Virtual Tours | The Park Avenue Lofts Apartments",
  "property_seo_description_virtualtours": "Step into the vibrant life at The Park Avenue Lofts in Little Rock, AR! Our stunning virtual tour showcases stylish studio, one-bedroom, and two-bedroom floor plans, inviting you to envision your new home. Experience modern elegance combined with community charm—take the virtual tour today and see why your dream apartment awaits!",
  "property_seo_title_interactivemap": "Interactive Map | The Park Avenue Lofts Apartments",
  "property_seo_description_interactivemap": "Unveil the ultimate living experience at The Park Avenue Lofts in Little Rock, AR, where style meets comfort. Choose from our diverse floor plans—studios, one and two-bedroom apartments—each designed with modern amenities like a cozy gas fire pit, Starbucks WiFi lounge, and convenient 24/7 management. Enjoy leisure days by the pool or discover our eco-friendly recycling initiatives. Ready to find your new home? Navigate through our interactive community map to see available apartments, pricing, and more!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Little Rock, AR",
  "property_seo_description_neighborhood": "\"Uncover the vibrant charm of Little Rock, AR, right outside your doorstep at The Park Avenue Lofts. From cozy studios to spacious two-bedroom layouts, our community embodies urban living and easy access to local favorites. Dive into nearby parks, restaurants, and cultural spots that make our neighborhood a delightful place to call home. Embrace the energy of city life and see what awaits you just around the corner!\"",
  "property_seo_title_contact": "Contact Us | The Park Avenue Lofts",
  "property_seo_description_contact": "Experience modern living at The Park Avenue Lofts in vibrant Little Rock, AR. From stylish studios to spacious two-bedroom apartments, we have the perfect floor plan for your lifestyle. Have questions? Reach out to our friendly leasing team today and find your ideal home in the heart of the city!",
  "property_seo_title_faqs": "FAQs | Apartments in Little Rock, AR",
  "property_seo_description_faqs": "\"Experience life at The Park Avenue Lofts in Little Rock, AR, where modern living meets thoughtful amenities. Whether you opt for a cozy studio or an expansive two-bedroom, enjoy upscale features like 24/7 maintenance, a relaxing gas fire pit, and a vibrant Starbucks WiFi Café. Have questions? Our FAQ page is your go-to for everything about our community, from floor plans to unique amenities. Let's make your next home a reality!\"",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Little Rock, AR",
  "property_seo_description_reviews": "Experience the vibrant lifestyle at The Park Avenue Lofts in Little Rock, AR, where modern comforts meet community charm. From studios to spacious two-bedroom apartments, every floor plan is designed for your unique lifestyle. Enjoy resort-style amenities including a Starbucks WiFi Cafe, gas fire pits, and eco-friendly recycling initiatives. Our dedicated team ensures 24/7 support, allowing you to relax and enjoy your new home. Read genuine resident reviews and see why The Park Avenue Lofts is the ideal place to live! ",
  "property_seo_title_applynow": "Apply Now | Apartments in Little Rock, AR",
  "property_seo_description_applynow": "Elevate your lifestyle at The Park Avenue Lofts in vibrant Little Rock, AR! Choose from stylish studio, one-bedroom, and two-bedroom floor plans, each designed for comfort and convenience. Enjoy top-notch amenities like a Starbucks WiFi Café, relaxing gas fire pit, and a dedicated clothes care center with smart card payments. With 24/7 on-call management and maintenance, your peace of mind is our priority. Unwind on your private balcony or embrace community living with our eco-friendly recycling program. Ready to make the move? Secure your dream apartment and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | The Park Avenue Lofts",
  "property_seo_description_residentaccess": "Unlock the convenience of modern living at The Park Avenue Lofts in Little Rock, AR. Log in to your resident portal for seamless rent payments, easy maintenance requests, and exclusive community updates—all at your fingertips!",
  "property_seo_title_referafriend": "Refer A Friend | The Park Avenue Lofts",
  "property_seo_description_referafriend": "\"Refer a friend to The Park Avenue Lofts in Little Rock, AR, and turn neighbors into lifelong friends! Share the vibrant lifestyle and stunning amenities that make our community a perfect place to call home. Join us in creating lasting connections today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | The Park Avenue Lofts",
  "property_seo_description_scheduletour": "\"Step into luxury living at The Park Avenue Lofts in Little Rock, AR. Experience spacious designs, modern amenities, and a vibrant community atmosphere. Ready to find your new home? Schedule your tour today!\"",
  "property_seo_title_privacy": "Privacy Policy | The Park Avenue Lofts",
  "property_seo_description_privacy": "\"At The Park Avenue Lofts in Little Rock, AR, your peace of mind matters. Dive into our comprehensive privacy policy to understand how we protect your information while you enjoy the comforts of urban living. View our privacy policy today!\"",
  "property_seo_title_accessibility": "Website Accessibility | The Park Avenue Lofts",
  "property_seo_description_accessibility": "\"At The Park Avenue Lofts in Little Rock, AR, we embrace digital inclusion for all residents. Our Accessibility Statement showcases our commitment to creating a welcoming community where everyone can thrive. Join us in ensuring a seamless online experience that meets diverse needs!\"",
  "property_seo_title_sitemap": "Sitemap | The Park Avenue Lofts",
  "property_seo_description_sitemap": "\"Navigate your future home at The Park Avenue Lofts in Little Rock, AR. Our sitemap provides a clear path to explore luxurious amenities, unique floor plans, and the vibrant community that awaits you. Start your journey today!\"",
  "property_seo_title_thankyou": "Thank You | The Park Avenue Lofts",
  "property_seo_description_thankyou": "\"Thank you for reaching out to The Park Avenue Lofts in Little Rock, AR! Your inquiry is important to us, and our dedicated team is excited to assist you on your journey to stylish living. Stay tuned for a prompt response!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Little Rock, AR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293650400",
  "amenities": [
    {
      "id": "ec_c4104466f4747272816010f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Maintenance On Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c62cedf21870adc5c322e83",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Property Manager On Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd2b9ec52daee6bd7ef7819f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_237344918f39581f322f32f1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Renters Insurance Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1e081de3fe9a568d067c9636",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Online Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dabf27eb34494e58cbd46b30",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Planned Social Activities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e55492001fb9bf68ce17726",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Pet Play Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4835157237635ddf74dce255",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Key Fob Entry",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9787332a4a319fc892698276",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_70e16562f48eb02a0b0428ca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab9025ff26094cc0bd57b04c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1104b302d7f66cf812523e98",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Corporate Suites",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_457d710162a0c76d81f38ec8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f43ef446db6c59dab0af159b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7bda6aa0fa45dde85c5b8f90",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30ab510feddace945436ec6a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Grill",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab8f300c77ba5e7349541415",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57c4f60867071d52b30faea8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f84908622be50d759e26f6de",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3a387d5cefad902602796676",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a2b310bbe385eb4320bba874",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Loft Layout*",
      "amount": "false",
      "description": "in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2858a7d7a30c0494ec2b7452",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "High Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c5722749c2f87f5cddbc459d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e71f90598699c5deb662ef3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Island Kitchen*",
      "amount": "false",
      "description": "in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b802a019f154818e1412e7a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Wi‑Fi",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04552b07f517b64e429d9abf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Heating",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5da80613e0c6a2a9e962ef3a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e4db0923946c0492837fe593",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b006de19dbf966f238548c19",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_79679885ef1c523f64eb2f64",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Security System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_96ea4914ccc4c7d400141026",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Storage Space",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2bf31b20b3d797eb97d40e68",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Double Vanities*",
      "amount": "false",
      "description": "in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ae397606f376800d3a757fc0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Tub/Shower",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8869c6877235fff53bdd8ea2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Sprinkler System",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f59a4e0ccdeb481dd95b2bf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Wheelchair Accessible (Rooms)",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35289016ac7991044653dd79",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f237aae577fed26a110e6945",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Ice Maker",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed8ba776d1a38ff46e5d7111",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_27e703bfa15183fa1958de50",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Pantry*",
      "amount": "false",
      "description": "in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_43969f69b5a02a988712351e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_45d836cee9a9a93e2c8c809b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58b89dfeecd483edfdf2b19b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Oven",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2d6ef99569f456f4cdbbd0d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Range",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fcefed02e508c72ac2be8d2b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fda6635a5c2701345527cafd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Carpet*",
      "amount": "false",
      "description": "in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40505aa69175072c41493f60",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Office*",
      "amount": "false",
      "description": "in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e6d06f80bd0aa3b31961785",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Views*",
      "amount": "false",
      "description": "in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d587140106d2436df52cded",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Linen Closet",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8965497237c55e8084d60931",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e1d30b005c37e14fa3d6932a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Large Bedrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a82471b1e4c772f00db3cd0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Balcony*",
      "amount": "false",
      "description": "in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c28f17c2d8740e6c2fa93023",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "external_id": "false",
      "title": "Patio*",
      "amount": "false",
      "description": "in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_40687c82-0556-4505-9337-0637cc0c544e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-f0a2-7458-ac61-e477296fa3a5.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior at twilight with dramatic purple and pink sky.",
        "public_id": "019e69a5-f0a2-7458-ac61-e477296fa3a5",
        "storage_key": "property/6737460151192619/019e69a5-f0a2-7458-ac61-e477296fa3a5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience modern living in this stunning apartment building, featuring contemporary architecture and a vibrant twilight sky. Enjoy the exterior view of the property.",
      "link": "",
      "alt_text": "Modern apartment building exterior at twilight with dramatic purple and pink sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ea658f1e-830c-4afa-9308-2ca6f24f41e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019fafd0-d0dd-7149-ad58-aef131cc0a16.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, adjacent to apartment building.",
        "public_id": "019fafd0-d0dd-7149-ad58-aef131cc0a16",
        "storage_key": "property/6737460151192619/019fafd0-d0dd-7149-ad58-aef131cc0a16.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable seating. Perfect for relaxation and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and cabanas, adjacent to apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4aa5b445-d511-47f1-bdfd-3a9c7f8092e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019fafd0-d25e-75fe-82ab-2357b51684fb.webp",
      "image_media": {
        "alt_text": "Studio apartment bedroom and kitchen area with modern furnishings.",
        "public_id": "019fafd0-d25e-75fe-82ab-2357b51684fb",
        "storage_key": "property/6737460151192619/019fafd0-d25e-75fe-82ab-2357b51684fb.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Stylish studio apartment featuring a comfortable bedroom, a fully equipped kitchen, and a dining area, perfect for modern living.",
      "link": "",
      "alt_text": "Studio apartment bedroom and kitchen area with modern furnishings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b0064fd5-40df-462d-9dee-0e417b9cc887",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019fafd0-d0ab-71a8-aafb-394cc530d519.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and stainless steel appliances",
        "public_id": "019fafd0-d0ab-71a8-aafb-394cc530d519",
        "storage_key": "property/6737460151192619/019fafd0-d0ab-71a8-aafb-394cc530d519.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring granite countertops, ample cabinet space, and stainless steel appliances, seamlessly flowing into the dining and living areas.",
      "link": "",
      "alt_text": "Modern kitchen with island and stainless steel appliances",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_40eabe3e-5535-4bba-8af6-f8865b16af46",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019fafd0-d592-77cc-937b-278795f1e919.webp",
      "image_media": {
        "alt_text": "Stylish living room with a modern sofa, accent chairs, and a geometric coffee table.",
        "public_id": "019fafd0-d592-77cc-937b-278795f1e919",
        "storage_key": "property/6737460151192619/019fafd0-d592-77cc-937b-278795f1e919.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living room, featuring a plush sofa, elegant accent chairs, and a captivating geometric coffee table.",
      "link": "",
      "alt_text": "Stylish living room with a modern sofa, accent chairs, and a geometric coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_24fbc56a-e86a-4537-9998-7a729b966e75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a8-4161-7197-836f-e21c30b21091.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, floor lamp, coffee tables, and shelving unit.",
        "public_id": "019e69a8-4161-7197-836f-e21c30b21091",
        "storage_key": "property/6737460151192619/019e69a8-4161-7197-836f-e21c30b21091.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable sectional sofa, a modern floor lamp, and decorative shelving, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a sectional sofa, floor lamp, coffee tables, and shelving unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0ad31cb4-d58a-40d6-8149-3785dccdc599",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019fafd0-d5e9-74cd-8e48-f84f6e5e1b5f.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and free weights.",
        "public_id": "019fafd0-d5e9-74cd-8e48-f84f6e5e1b5f",
        "storage_key": "property/6737460151192619/019fafd0-d5e9-74cd-8e48-f84f6e5e1b5f.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art cardio machines and a dedicated free weights area.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a849053b-b0a2-4ca1-89a5-efadd2c316fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a8-3c1a-72c7-9379-2bc8f112927a.webp",
      "image_media": {
        "alt_text": "Modern coffee station with a round table in the center and artwork on the wall.",
        "public_id": "019e69a8-3c1a-72c7-9379-2bc8f112927a",
        "storage_key": "property/6737460151192619/019e69a8-3c1a-72c7-9379-2bc8f112927a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and refreshments in our stylish community lounge area, featuring a modern coffee station and comfortable seating.",
      "link": "",
      "alt_text": "Modern coffee station with a round table in the center and artwork on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a5262347-79dc-4eef-9ad5-c576d1c5fab7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019fafd0-d5eb-767d-b4be-19bc21905744.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living area with island, sofa, and coffee tables.",
        "public_id": "019fafd0-d5eb-767d-b4be-19bc21905744",
        "storage_key": "property/6737460151192619/019fafd0-d5eb-767d-b4be-19bc21905744.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Experience sophisticated living in this open-concept apartment, featuring a gourmet kitchen, spacious living area, and elegant dining space.",
      "link": "",
      "alt_text": "Modern kitchen and living area with island, sofa, and coffee tables.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_72ab9971-6f4a-4d90-ab0c-a9631f325215",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a8-41b1-7656-b105-377dacca6410.webp",
      "image_media": {
        "alt_text": "Modern lounge area with communal table, seating, and abstract art.",
        "public_id": "019e69a8-41b1-7656-b105-377dacca6410",
        "storage_key": "property/6737460151192619/019e69a8-41b1-7656-b105-377dacca6410.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in the stylish communal lounge, featuring a large table, comfortable seating, and vibrant artwork.",
      "link": "",
      "alt_text": "Modern lounge area with communal table, seating, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bc919d5b-31cc-42e0-9a2a-9725edc32723",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a8-4484-7308-9244-0f225848a6a8.webp",
      "image_media": {
        "alt_text": "Spacious apartment complex lobby with seating areas and a reception desk.",
        "public_id": "019e69a8-4484-7308-9244-0f225848a6a8",
        "storage_key": "property/6737460151192619/019e69a8-4484-7308-9244-0f225848a6a8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our modern apartment complex lobby, featuring comfortable seating areas, a stylish reception desk, and an elegant chandelier.",
      "link": "",
      "alt_text": "Spacious apartment complex lobby with seating areas and a reception desk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_291023a9-b5aa-42a7-ba77-12db7145504c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a8-3928-708d-9922-4dac5c411f7a.webp",
      "image_media": {
        "alt_text": "Studio apartment with kitchen, living area, and bathroom.",
        "public_id": "019e69a8-3928-708d-9922-4dac5c411f7a",
        "storage_key": "property/6737460151192619/019e69a8-3928-708d-9922-4dac5c411f7a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious studio apartment featuring a modern kitchen, comfortable living space, and a well-appointed bathroom. Perfect for urban living.",
      "link": "",
      "alt_text": "Studio apartment with kitchen, living area, and bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d364ae3c-754a-447c-82bb-237b9329bfd7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019fafd0-d5f9-721c-ba24-c2868a21cd7d.webp",
      "image_media": {
        "alt_text": "Modern lounge area with sofas and armchairs around a coffee table.",
        "public_id": "019fafd0-d5f9-721c-ba24-c2868a21cd7d",
        "storage_key": "property/6737460151192619/019fafd0-d5f9-721c-ba24-c2868a21cd7d.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge, featuring comfortable seating and a contemporary design.",
      "link": "",
      "alt_text": "Modern lounge area with sofas and armchairs around a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_16fcf81f-89ee-409e-b741-82b3f5244c5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a8-3084-718e-8bc9-6a4acd1e4b12.webp",
      "image_media": {
        "alt_text": "State-of-the-art fitness center with treadmills, elliptical machines, and free weights.",
        "public_id": "019e69a8-3084-718e-8bc9-6a4acd1e4b12",
        "storage_key": "property/6737460151192619/019e69a8-3084-718e-8bc9-6a4acd1e4b12.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring treadmills, elliptical machines, and a free weight station. Your perfect workout awaits!",
      "link": "",
      "alt_text": "State-of-the-art fitness center with treadmills, elliptical machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b845c42a-eb62-4a7d-a466-6a475bccbe23",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a8-34d1-7740-9260-4ad268faf0f2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island.",
        "public_id": "019e69a8-34d1-7740-9260-4ad268faf0f2",
        "storage_key": "property/6737460151192619/019e69a8-34d1-7740-9260-4ad268faf0f2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed kitchen, featuring dark cabinetry, sleek countertops, and a spacious island perfect for meal prep and casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets, stainless steel appliances, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aa2014d5-29c0-42c5-aa59-63eda2989efe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a8-2eb8-76ba-a4f5-3baeb33a0c2f.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of a luxury apartment with modern furniture and decor.",
        "public_id": "019e69a8-2eb8-76ba-a4f5-3baeb33a0c2f",
        "storage_key": "property/6737460151192619/019e69a8-2eb8-76ba-a4f5-3baeb33a0c2f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully appointed apartment, featuring a spacious living area seamlessly connected to a modern kitchen.",
      "link": "",
      "alt_text": "Living room and kitchen area of a luxury apartment with modern furniture and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bd249d9f-5266-4754-a3b7-85514abc3046",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a8-32e4-770a-9f78-11518cdfbdac.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, toilet, and vanity with a sink.",
        "public_id": "019e69a8-32e4-770a-9f78-11518cdfbdac",
        "storage_key": "property/6737460151192619/019e69a8-32e4-770a-9f78-11518cdfbdac.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this clean and functional bathroom, featuring a bathtub, toilet, and a spacious vanity with ample counter space and storage.",
      "link": "",
      "alt_text": "Bathroom with a bathtub, toilet, and vanity with a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e038d053-6bec-4ecd-9e73-85449db42b59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a8-2d56-72c0-99a3-4f08a82e7c15.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
        "public_id": "019e69a8-2d56-72c0-99a3-4f08a82e7c15",
        "storage_key": "property/6737460151192619/019e69a8-2d56-72c0-99a3-4f08a82e7c15.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring granite countertops, stainless steel appliances, and custom cabinetry, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and ample cabinet space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1a929abc-5269-451e-8ad8-8642de598e68",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a8-2779-7218-b2f9-722ad3f974fb.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, large mirror, and view into bedroom.",
        "public_id": "019e69a8-2779-7218-b2f9-722ad3f974fb",
        "storage_key": "property/6737460151192619/019e69a8-2779-7218-b2f9-722ad3f974fb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this bright and airy bathroom featuring a spacious double vanity with ample counter space and storage, complemented by a large mirror and a glimpse into a serene bedroom.",
      "link": "",
      "alt_text": "Modern bathroom with double vanity, large mirror, and view into bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_167db9df-5794-423c-9661-af3250a01208",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a8-28d9-70e8-a1ba-20f7cbebc197.webp",
      "image_media": {
        "alt_text": "Bedroom with king-size bed, nightstands, chair, and window.",
        "public_id": "019e69a8-28d9-70e8-a1ba-20f7cbebc197",
        "storage_key": "property/6737460151192619/019e69a8-28d9-70e8-a1ba-20f7cbebc197.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in style in this spacious bedroom, featuring a comfortable king-size bed, elegant nightstands, and a cozy accent chair. Large windows provide ample natural light.",
      "link": "",
      "alt_text": "Bedroom with king-size bed, nightstands, chair, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_997f885c-4633-4332-84ab-fe755bb55eaf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a8-1c59-72d4-88fc-a40078601eee.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and a sitting area with a coffee table.",
        "public_id": "019e69a8-1c59-72d4-88fc-a40078601eee",
        "storage_key": "property/6737460151192619/019e69a8-1c59-72d4-88fc-a40078601eee.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and well-appointed bedroom featuring a king-size bed, comfortable seating area, and elegant decor.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, and a sitting area with a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c1c46946-79cc-4d6a-9b96-c99604939d40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a8-1e1c-746b-b319-ae581c38325e.webp",
      "image_media": {
        "alt_text": "Resort-style pool with lounge chairs and cabanas at a multifamily property.",
        "public_id": "019e69a8-1e1c-746b-b319-ae581c38325e",
        "storage_key": "property/6737460151192619/019e69a8-1e1c-746b-b319-ae581c38325e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style pool, complete with comfortable lounge chairs and shaded cabanas for your enjoyment.",
      "link": "",
      "alt_text": "Resort-style pool with lounge chairs and cabanas at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e58f4511-2cc0-4c42-b48e-6ed066578a5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a8-1996-7504-a9da-ea59541590b3.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen area with grills and seating.",
        "public_id": "019e69a8-1996-7504-a9da-ea59541590b3",
        "storage_key": "property/6737460151192619/019e69a8-1996-7504-a9da-ea59541590b3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining with state-of-the-art grills and comfortable seating areas.",
      "link": "",
      "alt_text": "Outdoor kitchen area with grills and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0f388639-4738-465f-bba3-6d885f33899a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a7-0b18-704f-8533-9c2e0a1134e8.webp",
      "image_media": {
        "alt_text": "Aerial view of a large, resort-style swimming pool with lounge chairs and cabanas.",
        "public_id": "019e69a7-0b18-704f-8533-9c2e0a1134e8",
        "storage_key": "property/6737460151192619/019e69a7-0b18-704f-8533-9c2e0a1134e8.webp",
        "width": 3072,
        "height": 2302
      },
      "title": "Community",
      "description": "Enjoy our stunning outdoor swimming pool, perfect for relaxing and soaking up the sun. Featuring ample lounge seating and shaded cabanas, it's your personal oasis.",
      "link": "",
      "alt_text": "Aerial view of a large, resort-style swimming pool with lounge chairs and cabanas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_702b27ff-4c38-406e-b08d-d42c72d131b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-ccf2-704b-80b5-7a3b43a71b63.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, modern artwork, and glass-enclosed shower.",
        "public_id": "019e69a6-ccf2-704b-80b5-7a3b43a71b63",
        "storage_key": "property/6737460151192619/019e69a6-ccf2-704b-80b5-7a3b43a71b63.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience the modern elegance of this spacious bathroom, featuring a double vanity, contemporary artwork, and a sleek glass-enclosed shower.",
      "link": "",
      "alt_text": "Bathroom with double vanity, modern artwork, and glass-enclosed shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_410690a2-a1b3-4a20-8844-c24139b339b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-cd53-72d3-a4c3-9210ee67ad62.webp",
      "image_media": {
        "alt_text": "Aerial view of a mixed-use development with apartment buildings and retail spaces at dusk.",
        "public_id": "019e69a6-cd53-72d3-a4c3-9210ee67ad62",
        "storage_key": "property/6737460151192619/019e69a6-cd53-72d3-a4c3-9210ee67ad62.webp",
        "width": 3072,
        "height": 2302
      },
      "title": "Community",
      "description": "Experience vibrant living in this mixed-use community featuring modern apartments and a variety of retail and dining options.",
      "link": "",
      "alt_text": "Aerial view of a mixed-use development with apartment buildings and retail spaces at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9a5056e0-5ff8-4614-8971-d22f86a58f9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-cea5-7353-a0ee-d1e519e0ab75.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite island and dining area.",
        "public_id": "019e69a6-cea5-7353-a0ee-d1e519e0ab75",
        "storage_key": "property/6737460151192619/019e69a6-cea5-7353-a0ee-d1e519e0ab75.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience the perfect blend of style and comfort in our spacious apartment kitchens, featuring granite countertops and ample dining space.",
      "link": "",
      "alt_text": "Modern kitchen with granite island and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_238ceb0c-f4db-4a1b-964a-0f73b50fed42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-cce3-777b-a991-3aaa3965ca55.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and living room view.",
        "public_id": "019e69a6-cce3-777b-a991-3aaa3965ca55",
        "storage_key": "property/6737460151192619/019e69a6-cce3-777b-a991-3aaa3965ca55.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring a large island, ample cabinet space, and a seamless transition to the living area.",
      "link": "",
      "alt_text": "Modern kitchen with island and living room view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_edc3fb8f-442d-4854-b367-4ee30999f3a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-c381-7782-81c2-4c743d3d6a26.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and an island.",
        "public_id": "019e69a6-c381-7782-81c2-4c743d3d6a26",
        "storage_key": "property/6737460151192619/019e69a6-c381-7782-81c2-4c743d3d6a26.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this stunning kitchen, featuring sleek dark wood cabinetry, modern black appliances, and a spacious island perfect for meal prep or casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and an island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e96795af-4bd9-4922-889a-0ad6de16b0d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-c39a-7541-870e-374b1b9499a7.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, nightstands, and a sitting area.",
        "public_id": "019e69a6-c39a-7541-870e-374b1b9499a7",
        "storage_key": "property/6737460151192619/019e69a6-c39a-7541-870e-374b1b9499a7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-sized bed, elegant decor, and a comfortable seating area, perfect for relaxation.",
      "link": "",
      "alt_text": "Bedroom with a large bed, nightstands, and a sitting area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7e9d5a28-cae7-42f3-a811-d86af0199125",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-b8d1-7537-be8a-91f9b3cff582.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and a large closet.",
        "public_id": "019e69a6-b8d1-7537-be8a-91f9b3cff582",
        "storage_key": "property/6737460151192619/019e69a6-b8d1-7537-be8a-91f9b3cff582.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, modern nightstands, and a walk-in closet.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, nightstands, and a large closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0fcdb0ff-9930-4db8-b3c8-1e3d584a173a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-b869-738e-84f9-7ddcfd935a13.webp",
      "image_media": {
        "alt_text": "Modern dining and living area with natural light, modern decor, and artwork.",
        "public_id": "019e69a6-b869-738e-84f9-7ddcfd935a13",
        "storage_key": "property/6737460151192619/019e69a6-b869-738e-84f9-7ddcfd935a13.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the spacious and elegantly designed living and dining areas, perfect for entertaining or relaxing. Features natural light, modern finishes, and stylish decor.",
      "link": "",
      "alt_text": "Modern dining and living area with natural light, modern decor, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_321c77c3-e825-4b41-8a33-ea435c1b32aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-a989-74f4-96f5-f59a35fc9b6b.webp",
      "image_media": {
        "alt_text": "Living room and dining area of a multifamily apartment.",
        "public_id": "019e69a6-a989-74f4-96f5-f59a35fc9b6b",
        "storage_key": "property/6737460151192619/019e69a6-a989-74f4-96f5-f59a35fc9b6b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A beautifully furnished living and dining area in a multifamily apartment, perfect for entertaining guests or relaxing after a long day.",
      "link": "",
      "alt_text": "Living room and dining area of a multifamily apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4f9d9da2-acb0-46b7-b895-21d64db6ef82",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-a459-744a-9d49-47482303b7df.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, two round wooden coffee tables, and a large abstract painting.",
        "public_id": "019e69a6-a459-744a-9d49-47482303b7df",
        "storage_key": "property/6737460151192619/019e69a6-a459-744a-9d49-47482303b7df.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in style in this beautifully appointed living room featuring a comfortable sectional sofa, elegant coffee tables, and tasteful decor.",
      "link": "",
      "alt_text": "Living room with a sectional sofa, two round wooden coffee tables, and a large abstract painting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c8f2e19e-900f-4b01-b744-47e646dff30f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-9f36-70df-af2d-6e16990e9685.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and a large island with a breakfast bar.",
        "public_id": "019e69a6-9f36-70df-af2d-6e16990e9685",
        "storage_key": "property/6737460151192619/019e69a6-9f36-70df-af2d-6e16990e9685.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark wood cabinetry, sleek black appliances, granite countertops, and a convenient island perfect for casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and a large island with a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b0960499-9ebb-4ee7-8f55-16d07fecb8e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-837a-779c-92c5-e98209ba35db.webp",
      "image_media": {
        "alt_text": "Aerial view of a mixed-use development at sunset, featuring apartment buildings and commercial spaces like LA Fitness.",
        "public_id": "019e69a6-837a-779c-92c5-e98209ba35db",
        "storage_key": "property/6737460151192619/019e69a6-837a-779c-92c5-e98209ba35db.webp",
        "width": 3072,
        "height": 2302
      },
      "title": "Community",
      "description": "Experience vibrant city living with our modern apartments and convenient retail spaces, all set against a stunning sunset backdrop.",
      "link": "",
      "alt_text": "Aerial view of a mixed-use development at sunset, featuring apartment buildings and commercial spaces like LA Fitness.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e30ecb50-58c1-4942-ab9c-564150ecdc2f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-88ae-73c8-b762-8efccbfb585a.webp",
      "image_media": {
        "alt_text": "Master bedroom with a king-size bed, bedside tables, and a chair.",
        "public_id": "019e69a6-88ae-73c8-b762-8efccbfb585a",
        "storage_key": "property/6737460151192619/019e69a6-88ae-73c8-b762-8efccbfb585a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in style in this beautifully appointed master bedroom, featuring a plush king-size bed, elegant decor, and ample natural light.",
      "link": "",
      "alt_text": "Master bedroom with a king-size bed, bedside tables, and a chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_afb931d3-c534-4210-8e1e-770c88f02c98",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-84ab-75c0-80ea-a87eab77c043.webp",
      "image_media": {
        "alt_text": "Kitchen island with bar stools, dining area with table and chairs, and glimpse into bedroom.",
        "public_id": "019e69a6-84ab-75c0-80ea-a87eab77c043",
        "storage_key": "property/6737460151192619/019e69a6-84ab-75c0-80ea-a87eab77c043.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy this bright and airy kitchen and dining area, perfect for entertaining. This space seamlessly connects to the comfortable living area and private bedrooms.",
      "link": "",
      "alt_text": "Kitchen island with bar stools, dining area with table and chairs, and glimpse into bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_361a1412-a1b1-4c2d-8f24-2a6b0e327365",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-7a80-7798-8286-dca237469115.webp",
      "image_media": {
        "alt_text": "Dining area with chairs and a banquette, overlooking the kitchen.",
        "public_id": "019e69a6-7a80-7798-8286-dca237469115",
        "storage_key": "property/6737460151192619/019e69a6-7a80-7798-8286-dca237469115.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a meal in the open-concept dining area, perfectly situated next to the spacious kitchen.",
      "link": "",
      "alt_text": "Dining area with chairs and a banquette, overlooking the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f5bfd913-4b52-4b60-ab08-082dae7f901f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-6e88-760d-bf97-12918e79415a.webp",
      "image_media": {
        "alt_text": "Spacious living room with a TV, couch, coffee table, and armchair.",
        "public_id": "019e69a6-6e88-760d-bf97-12918e79415a",
        "storage_key": "property/6737460151192619/019e69a6-6e88-760d-bf97-12918e79415a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this beautifully appointed living room, perfect for entertaining or unwinding after a long day. Features a mounted TV, comfortable seating, and elegant decor.",
      "link": "",
      "alt_text": "Spacious living room with a TV, couch, coffee table, and armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e99ec688-93c5-4c7f-a69d-8c76b0ba9820",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-6b48-777a-a222-ddf673a8ee69.webp",
      "image_media": {
        "alt_text": "Studio apartment living and sleeping area with a sectional sofa, bed, and decor.",
        "public_id": "019e69a6-6b48-777a-a222-ddf673a8ee69",
        "storage_key": "property/6737460151192619/019e69a6-6b48-777a-a222-ddf673a8ee69.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious studio apartment featuring a comfortable living area with a sectional sofa and a separate sleeping space with a queen-sized bed, perfect for modern living.",
      "link": "",
      "alt_text": "Studio apartment living and sleeping area with a sectional sofa, bed, and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9d9b7537-5210-41bd-95b6-ec628caa1fd6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-6342-7738-b6c9-dfa465d53b39.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, a sitting area with a sofa and chairs, and large windows.",
        "public_id": "019e69a6-6342-7738-b6c9-dfa465d53b39",
        "storage_key": "property/6737460151192619/019e69a6-6342-7738-b6c9-dfa465d53b39.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, a cozy seating area, and abundant natural light from large windows.",
      "link": "",
      "alt_text": "Bedroom with a large bed, a sitting area with a sofa and chairs, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_55fa755f-d0b2-4f8d-ac1e-f9e0c2774e85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-6153-74f7-aaa7-8269b73cc1e3.webp",
      "image_media": {
        "alt_text": "Living room with a television, sofa, coffee table, and rustic sideboard.",
        "public_id": "019e69a6-6153-74f7-aaa7-8269b73cc1e3",
        "storage_key": "property/6737460151192619/019e69a6-6153-74f7-aaa7-8269b73cc1e3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished living room featuring a large flat-screen TV, comfortable sofa, glass-top coffee table, and a stylish rustic sideboard.",
      "link": "",
      "alt_text": "Living room with a television, sofa, coffee table, and rustic sideboard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f8de1524-cb07-4059-9b87-b10e30304ad8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-6047-71dc-a346-621d0184b937.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen and dining area with island seating and artwork.",
        "public_id": "019e69a6-6047-71dc-a346-621d0184b937",
        "storage_key": "property/6737460151192619/019e69a6-6047-71dc-a346-621d0184b937.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and stylish apartment featuring a modern kitchen with an island, comfortable dining area, and tasteful decor.",
      "link": "",
      "alt_text": "Modern apartment kitchen and dining area with island seating and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9d56bb04-fd16-4ed5-8f5b-b3d988d79e89",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-5bc6-7258-80cd-5ed6f6601fa6.webp",
      "image_media": {
        "alt_text": "Spacious kitchen with dark wood cabinets, a large island, and modern appliances.",
        "public_id": "019e69a6-5bc6-7258-80cd-5ed6f6601fa6",
        "storage_key": "property/6737460151192619/019e69a6-5bc6-7258-80cd-5ed6f6601fa6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience modern living in this beautifully appointed kitchen, featuring ample cabinet space, a central island for prep and dining, and sleek, contemporary appliances.",
      "link": "",
      "alt_text": "Spacious kitchen with dark wood cabinets, a large island, and modern appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6cedc376-5ed6-4ea9-9d36-a1b5afc218df",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-59a6-74ae-91e4-170948b565f2.webp",
      "image_media": {
        "alt_text": "Bedroom and living area in an apartment",
        "public_id": "019e69a6-59a6-74ae-91e4-170948b565f2",
        "storage_key": "property/6737460151192619/019e69a6-59a6-74ae-91e4-170948b565f2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom with a king-size bed and a separate sitting area with a sofa and chairs. Modern decor and natural light create a comfortable living space.",
      "link": "",
      "alt_text": "Bedroom and living area in an apartment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_efadc4f3-076a-4035-9e9d-f973265f92e4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-3650-7102-9d97-916f0dc4b844.webp",
      "image_media": {
        "alt_text": "Cozy living room with a cream sofa, accent chair, coffee table, and botanical art.",
        "public_id": "019e69a6-3650-7102-9d97-916f0dc4b844",
        "storage_key": "property/6737460151192619/019e69a6-3650-7102-9d97-916f0dc4b844.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully furnished living room, featuring a plush sofa, accent chair, and elegant decor.",
      "link": "",
      "alt_text": "Cozy living room with a cream sofa, accent chair, coffee table, and botanical art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_85745f54-5b85-41ac-8a0a-cf828d1a7e19",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-2a56-70d9-9987-833bebcebe8d.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, entryway to bathroom, and living area with sofa.",
        "public_id": "019e69a6-2a56-70d9-9987-833bebcebe8d",
        "storage_key": "property/6737460151192619/019e69a6-2a56-70d9-9987-833bebcebe8d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, leading to a well-appointed bathroom. The adjacent living area boasts a stylish sofa and coffee table.",
      "link": "",
      "alt_text": "Bedroom with a large bed, entryway to bathroom, and living area with sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a2358f62-8688-4220-b53f-8b585cabd5ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-26eb-761c-a249-d66c8357988b.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with a large mirror.",
        "public_id": "019e69a6-26eb-761c-a249-d66c8357988b",
        "storage_key": "property/6737460151192619/019e69a6-26eb-761c-a249-d66c8357988b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the convenience and comfort of this well-appointed bathroom, featuring a spacious vanity, ample storage, and a relaxing bathtub.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, toilet, and vanity with a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5835fdc4-76eb-42a8-907f-64f9de75a81b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-2877-730a-82f9-c563c1857d1a.webp",
      "image_media": {
        "alt_text": "Living room with a couch, coffee table, and a view through a doorway to another room.",
        "public_id": "019e69a6-2877-730a-82f9-c563c1857d1a",
        "storage_key": "property/6737460151192619/019e69a6-2877-730a-82f9-c563c1857d1a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable couch, a modern coffee table, and elegant decor. Opens to an additional living space.",
      "link": "",
      "alt_text": "Living room with a couch, coffee table, and a view through a doorway to another room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d947caf5-7d68-4120-9262-23c89d7d1ca1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-1f71-72fe-9bde-e20eeb29bc76.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen in an apartment.",
        "public_id": "019e69a6-1f71-72fe-9bde-e20eeb29bc76",
        "storage_key": "property/6737460151192619/019e69a6-1f71-72fe-9bde-e20eeb29bc76.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A modern dining area with a marble-top table and plush seating, adjacent to a fully equipped kitchen with warm wood cabinetry.",
      "link": "",
      "alt_text": "Dining area and kitchen in an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8080b721-1c14-4763-a212-905d0e9858f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-1834-72cb-90b0-9b37f8ddfeb5.webp",
      "image_media": {
        "alt_text": "Stylish living room with TV, modern furniture, and large windows.",
        "public_id": "019e69a6-1834-72cb-90b0-9b37f8ddfeb5",
        "storage_key": "property/6737460151192619/019e69a6-1834-72cb-90b0-9b37f8ddfeb5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed living room, featuring a mounted flat-screen TV, elegant seating, and ample natural light.",
      "link": "",
      "alt_text": "Stylish living room with TV, modern furniture, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b958d2ef-afe0-406f-bfaa-5d789c910612",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-0561-761f-a08f-944c7ace93c7.webp",
      "image_media": {
        "alt_text": "Stylish studio apartment with a living area, bedroom, and dining nook.",
        "public_id": "019e69a6-0561-761f-a08f-944c7ace93c7",
        "storage_key": "property/6737460151192619/019e69a6-0561-761f-a08f-944c7ace93c7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover modern living in this chic studio apartment, featuring a comfortable living space, a private bedroom area, and a convenient dining nook, perfect for any lifestyle.",
      "link": "",
      "alt_text": "Stylish studio apartment with a living area, bedroom, and dining nook.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fd640e46-11ec-4181-9020-35accd98f427",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a6-02b0-7388-825c-b8fd0965c6b5.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-sized bed, nightstands, a comfortable armchair, and decorative wall art.",
        "public_id": "019e69a6-02b0-7388-825c-b8fd0965c6b5",
        "storage_key": "property/6737460151192619/019e69a6-02b0-7388-825c-b8fd0965c6b5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in the comfort of our beautifully appointed bedrooms, featuring plush bedding, elegant furnishings, and serene decor for a peaceful retreat.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-sized bed, nightstands, a comfortable armchair, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bdc579f2-7c85-4498-bdf0-5d2fcdb4dade",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-fd94-71b9-9d78-41fe86efcddd.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity, soaking tub, and walk-in closet.",
        "public_id": "019e69a5-fd94-71b9-9d78-41fe86efcddd",
        "storage_key": "property/6737460151192619/019e69a5-fd94-71b9-9d78-41fe86efcddd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with ample counter space, a large soaking tub, and a walk-in closet for all your storage needs.",
      "link": "",
      "alt_text": "Bathroom with double vanity, soaking tub, and walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c46c932c-df5e-4d84-9f80-a399718b34ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-f67a-7388-8eb6-83451479b4c2.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019e69a5-f67a-7388-8eb6-83451479b4c2",
        "storage_key": "property/6737460151192619/019e69a5-f67a-7388-8eb6-83451479b4c2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and the modern architecture of the apartment buildings.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9e41e072-6282-4362-bd2d-63118e5ccbf4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019fafd0-d5fb-755c-ae03-79d1a63447bf.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a bar and pool view",
        "public_id": "019fafd0-d5fb-755c-ae03-79d1a63447bf",
        "storage_key": "property/6737460151192619/019fafd0-d5fb-755c-ae03-79d1a63447bf.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Enjoy the community's outdoor space with a bar and seating area adjacent to the pool.",
      "link": "",
      "alt_text": "Outdoor seating area with a bar and pool view",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_09763e41-108d-4908-b6c0-5518b9ebd947",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-e961-725a-b53f-e3907cca1d80.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with a swimming pool and lounge area.",
        "public_id": "019e69a5-e961-725a-b53f-e3907cca1d80",
        "storage_key": "property/6737460151192619/019e69a5-e961-725a-b53f-e3907cca1d80.webp",
        "width": 3072,
        "height": 2302
      },
      "title": "Community",
      "description": "Enjoy resort-style living at our apartment community, featuring a sparkling swimming pool, comfortable lounge areas, and lush landscaping.",
      "link": "",
      "alt_text": "Aerial view of apartment complex with a swimming pool and lounge area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ddad2259-a691-40ec-afa8-a9bf90b76b57",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-f1ca-7199-9689-907fae0e920f.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior at sunset with colorful lights on the top floor.",
        "public_id": "019e69a5-f1ca-7199-9689-907fae0e920f",
        "storage_key": "property/6737460151192619/019e69a5-f1ca-7199-9689-907fae0e920f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience luxury living in this stunning apartment building, featuring vibrant sunset views and modern architecture.",
      "link": "",
      "alt_text": "Modern apartment building exterior at sunset with colorful lights on the top floor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2afef5b4-1171-40f9-903d-e7915a01878f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-ead2-7261-a715-0cfa4272af5b.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with red and gray facades and balconies at dusk.",
        "public_id": "019e69a5-ead2-7261-a715-0cfa4272af5b",
        "storage_key": "property/6737460151192619/019e69a5-ead2-7261-a715-0cfa4272af5b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring red and gray facades, balconies, and ground-floor retail spaces, captured at twilight.",
      "link": "",
      "alt_text": "Apartment building exterior with red and gray facades and balconies at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9a7ac7e2-a92a-49f1-8c0f-31ddec8be381",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-e6ad-77b4-ad41-a8d6a7024112.webp",
      "image_media": {
        "alt_text": "Park Avenue monument sign with multiple businesses and apartment buildings in the background at sunset.",
        "public_id": "019e69a5-e6ad-77b4-ad41-a8d6a7024112",
        "storage_key": "property/6737460151192619/019e69a5-e6ad-77b4-ad41-a8d6a7024112.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Park Avenue monument sign with multiple businesses like LA Fitness, Panera Bread, Sprint, and apartment buildings in the background during a vibrant sunset.",
      "link": "",
      "alt_text": "Park Avenue monument sign with multiple businesses and apartment buildings in the background at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5c115736-e8c1-48c0-a373-27af756fe921",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-b97c-7348-9460-4a528dfdde39.webp",
      "image_media": {
        "alt_text": "Exterior view of Park Avenue Lofts apartment building at dusk with a sign in the foreground.",
        "public_id": "019e69a5-b97c-7348-9460-4a528dfdde39",
        "storage_key": "property/6737460151192619/019e69a5-b97c-7348-9460-4a528dfdde39.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience modern living at Park Avenue Lofts. This exterior view showcases the building's architecture and vibrant community atmosphere.",
      "link": "",
      "alt_text": "Exterior view of Park Avenue Lofts apartment building at dusk with a sign in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b56c9c1c-7ce2-4026-92d6-99a355b9a24c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-c02b-7289-89a0-a57cb1c5751c.webp",
      "image_media": {
        "alt_text": "Open concept living room and kitchen with modern furniture and decor.",
        "public_id": "019e69a5-c02b-7289-89a0-a57cb1c5751c",
        "storage_key": "property/6737460151192619/019e69a5-c02b-7289-89a0-a57cb1c5751c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfortable living in this beautifully appointed apartment, featuring a spacious open-concept layout with a modern kitchen and inviting living area.",
      "link": "",
      "alt_text": "Open concept living room and kitchen with modern furniture and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a0dc241c-5cc2-475e-a5bb-6283174b87fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-bb29-7578-be2e-a6b5635f59e3.webp",
      "image_media": {
        "alt_text": "Modern apartment building with an outdoor swimming pool and lounge seating.",
        "public_id": "019e69a5-bb29-7578-be2e-a6b5635f59e3",
        "storage_key": "property/6737460151192619/019e69a5-bb29-7578-be2e-a6b5635f59e3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the resort-style living with our beautiful outdoor swimming pool and comfortable lounge area. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Modern apartment building with an outdoor swimming pool and lounge seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_29ccf463-8604-4041-8935-b23af117d60e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-b97b-7069-ba01-e978e213693d.webp",
      "image_media": {
        "alt_text": "Courtyard with swimming pool and lounge chairs",
        "public_id": "019e69a5-b97b-7069-ba01-e978e213693d",
        "storage_key": "property/6737460151192619/019e69a5-b97b-7069-ba01-e978e213693d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling swimming pool and unwind in comfortable lounge chairs in the beautiful courtyard.",
      "link": "",
      "alt_text": "Courtyard with swimming pool and lounge chairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_004eba9e-3abc-4e17-8665-317d8154584f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-ae9f-7433-b306-27feef80d2fb.webp",
      "image_media": {
        "alt_text": "Kitchen island with granite countertop and stools, stainless steel appliances, and wood cabinets.",
        "public_id": "019e69a5-ae9f-7433-b306-27feef80d2fb",
        "storage_key": "property/6737460151192619/019e69a5-ae9f-7433-b306-27feef80d2fb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring a granite-topped island with seating, stainless steel appliances including a refrigerator, oven, and microwave, all complemented by warm wood cabinetry.",
      "link": "",
      "alt_text": "Kitchen island with granite countertop and stools, stainless steel appliances, and wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c38e839c-420c-4803-9310-c2e3713f2211",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-aa7b-733d-a344-2e07f1ccfebe.webp",
      "image_media": {
        "alt_text": "Park Avenue monument sign with directions to retail and residential parking, with apartment buildings in the background during sunset.",
        "public_id": "019e69a5-aa7b-733d-a344-2e07f1ccfebe",
        "storage_key": "property/6737460151192619/019e69a5-aa7b-733d-a344-2e07f1ccfebe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience vibrant city living at Park Avenue, featuring convenient retail and residential parking. Enjoy stunning sunset views from your home.",
      "link": "",
      "alt_text": "Park Avenue monument sign with directions to retail and residential parking, with apartment buildings in the background during sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_01e78eb1-6715-49b0-b6a7-cfc0077c474d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-a7ad-708b-b6b3-4e8ad55ca22c.webp",
      "image_media": {
        "alt_text": "Courtyard pool with lounge chairs and reflection of building.",
        "public_id": "019e69a5-a7ad-708b-b6b3-4e8ad55ca22c",
        "storage_key": "property/6737460151192619/019e69a5-a7ad-708b-b6b3-4e8ad55ca22c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling pool and enjoy the resort-style living at this multifamily property.",
      "link": "",
      "alt_text": "Courtyard pool with lounge chairs and reflection of building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e28f9c04-2df9-4071-aa6a-4c9c7c4dfde1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-b803-72da-8350-184a9bf38d50.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with balconies and trees",
        "public_id": "019e69a5-b803-72da-8350-184a9bf38d50",
        "storage_key": "property/6737460151192619/019e69a5-b803-72da-8350-184a9bf38d50.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Contemporary apartment building exterior with balconies, lush trees, and outdoor seating areas, showcasing the property's modern architecture and welcoming ambiance.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building with balconies and trees",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_954c091a-46d5-4a92-982a-50d9027eb807",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-b690-7409-896a-5df5e6518847.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen area with seating, TV, and pool view.",
        "public_id": "019e69a5-b690-7409-896a-5df5e6518847",
        "storage_key": "property/6737460151192619/019e69a5-b690-7409-896a-5df5e6518847.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor living with this fully equipped outdoor kitchen, complete with seating, a TV, and a view of the pool.",
      "link": "",
      "alt_text": "Outdoor kitchen area with seating, TV, and pool view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ae373757-78f2-4fd9-b9cc-05b69847a0b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-9735-71de-88a0-52bd742a668a.webp",
      "image_media": {
        "alt_text": "Modern apartment building with an outdoor swimming pool and lounge chairs.",
        "public_id": "019e69a5-9735-71de-88a0-52bd742a668a",
        "storage_key": "property/6737460151192619/019e69a5-9735-71de-88a0-52bd742a668a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the sunshine by the sparkling outdoor swimming pool, complete with comfortable lounge chairs for ultimate relaxation.",
      "link": "",
      "alt_text": "Modern apartment building with an outdoor swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c56cf5f6-fca7-488c-af1f-a944c0425114",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-713e-7111-9162-af564a03aede.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior at sunset with colorful sky and exterior lighting.",
        "public_id": "019e69a5-713e-7111-9162-af564a03aede",
        "storage_key": "property/6737460151192619/019e69a5-713e-7111-9162-af564a03aede.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience luxury living in this modern apartment building, featuring vibrant exterior lighting and a stunning sunset view. Explore our community amenities.",
      "link": "",
      "alt_text": "Modern apartment building exterior at sunset with colorful sky and exterior lighting.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9f7f2131-48bf-4f74-9642-9c9130677e53",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-6f5c-75c9-a301-cb62a96a908e.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with colorful lights on the roof at sunset.",
        "public_id": "019e69a5-6f5c-75c9-a301-cb62a96a908e",
        "storage_key": "property/6737460151192619/019e69a5-6f5c-75c9-a301-cb62a96a908e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience luxury living at this modern apartment building. Enjoy vibrant city views and a prime location. Now leasing!",
      "link": "",
      "alt_text": "Modern apartment building exterior with colorful lights on the roof at sunset.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ebe18db0-32bc-4ab3-a359-ab2051018527",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-5f97-73fd-ad39-9ec59cf7123e.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with two built-in grills and a bar seating area.",
        "public_id": "019e69a5-5f97-73fd-ad39-9ec59cf7123e",
        "storage_key": "property/6737460151192619/019e69a5-5f97-73fd-ad39-9ec59cf7123e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy convenient outdoor grilling with our community's well-equipped outdoor kitchen and dining area, perfect for social gatherings.",
      "link": "",
      "alt_text": "Outdoor kitchen with two built-in grills and a bar seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_791c640f-2568-4016-9667-06bd2e14b6ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-685b-72db-9994-5836d23f0948.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with balconies and warm lighting at dusk.",
        "public_id": "019e69a5-685b-72db-9994-5836d23f0948",
        "storage_key": "property/6737460151192619/019e69a5-685b-72db-9994-5836d23f0948.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience luxury living in this modern apartment building. Enjoy stylish balconies and beautiful evening views.",
      "link": "",
      "alt_text": "Modern apartment building exterior with balconies and warm lighting at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5547fd9d-8f5d-483e-b984-05c4a04acf0d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-44d9-744c-b383-09415245251e.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building at dusk with a red accent wall and balconies.",
        "public_id": "019e69a5-44d9-744c-b383-09415245251e",
        "storage_key": "property/6737460151192619/019e69a5-44d9-744c-b383-09415245251e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Experience modern living in this stunning apartment building. Enjoy the sleek design and comfortable balconies, perfect for relaxing evenings.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment building at dusk with a red accent wall and balconies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_24ee796b-d9c8-4da4-a62f-72334cf4abb0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-3bdd-717a-b450-58019a9600f8.webp",
      "image_media": {
        "alt_text": "Modern apartment building with a large swimming pool and fire pit.",
        "public_id": "019e69a5-3bdd-717a-b450-58019a9600f8",
        "storage_key": "property/6737460151192619/019e69a5-3bdd-717a-b450-58019a9600f8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the resort-style pool or gather around the fire pit at this modern community. Enjoy comfortable outdoor living with ample lounge seating and a beautiful backdrop.",
      "link": "",
      "alt_text": "Modern apartment building with a large swimming pool and fire pit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c3211d74-9a2b-4819-a148-4a2e287fc00f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e69a5-3b4f-70db-ae26-8249e2d836af.webp",
      "image_media": {
        "alt_text": "LA Fitness building exterior with cars in parking lot at dusk.",
        "public_id": "019e69a5-3b4f-70db-ae26-8249e2d836af",
        "storage_key": "property/6737460151192619/019e69a5-3b4f-70db-ae26-8249e2d836af.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of the LA Fitness building at dusk, featuring a large sign and a parking lot filled with cars.",
      "link": "",
      "alt_text": "LA Fitness building exterior with cars in parking lot at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_138ad2e8-c218-4e1b-8ffc-3064dc2930ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019fafd0-d0c0-77df-b1a5-26fc33ed0d5c.webp",
      "image_media": {
        "alt_text": "View of a bathroom vanity with a sink, toilet, and a doorway leading to a bedroom.",
        "public_id": "019fafd0-d0c0-77df-b1a5-26fc33ed0d5c",
        "storage_key": "property/6737460151192619/019fafd0-d0c0-77df-b1a5-26fc33ed0d5c.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a spacious vanity with a sink, ample storage, and a toilet. A doorway opens to a well-appointed bedroom.",
      "link": "",
      "alt_text": "View of a bathroom vanity with a sink, toilet, and a doorway leading to a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_be77b988-e521-4c98-8949-d2889b0f7829",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "314 S University Ave Suite 100, Little Rock, AR 72205, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-cd21-7497-b9bc-3636de958cd3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-cd21-7497-b9bc-3636de958cd3",
        "storage_key": "property/6737460151192619/019e1e0b-cd21-7497-b9bc-3636de958cd3.webp",
        "width": 1280,
        "height": 1129
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/ar/little-rock/314-south-university?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=606207&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=9649131720403536183&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "34.7502492",
      "poi_longitude": "-92.3421552",
      "poi_miles_from_property": "0.07",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 501-664-6878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0c-1c67-703b-ab37-0532c4d5d1c4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-1c67-703b-ab37-0532c4d5d1c4",
        "storage_key": "property/6737460151192619/019e1e0c-1c67-703b-ab37-0532c4d5d1c4.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ2bSnEoCk0ocRN0mbKS2a6IU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_94a2b052-b4bd-4b76-8fd7-74c889f65f36",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Newk's Eatery",
      "poi_type": "Restaurants",
      "poi_address": "314 S University Ave Suite 180, Little Rock, AR 72205, USA",
      "poi_short_description": "Regional chain offering a menu of salads, pizzas & sandwiches in a casual setting.",
      "poi_long_description": "Regional chain offering a menu of salads, pizzas & sandwiches in a casual setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-c90e-73f9-9a74-0be9af428bb1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-c90e-73f9-9a74-0be9af428bb1",
        "storage_key": "property/6737460151192619/019e1e0b-c90e-73f9-9a74-0be9af428bb1.webp",
        "width": 1024,
        "height": 767
      },
      "poi_business_url": "https://locations.newks.com/ar/little-rock/314-s-university-ave/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12566306720602507852&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newks-eatery",
      "poi_latitude": "34.750221",
      "poi_longitude": "-92.342752",
      "poi_miles_from_property": "0.04",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 501-663-6395",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8478-70aa-accf-f1328dcb22c8",
        "storage_key": "property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT36bcoCk0ocRTModHGJ9ZK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c202899f-acad-48bb-88a7-b24be0a4134b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "400 S University Ave, Little Rock, AR 72205, USA",
      "poi_short_description": "Family-friendly chain serving American comfort food with a Texas twist, plus cocktails.",
      "poi_long_description": "Family-friendly chain serving American comfort food with a Texas twist, plus cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-41b8-755a-b04c-d32e8c3675a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e09-41b8-755a-b04c-d32e8c3675a0",
        "storage_key": "property/6737460151192619/019e1e09-41b8-755a-b04c-d32e8c3675a0.webp",
        "width": 816,
        "height": 612
      },
      "poi_business_url": "https://www.cheddars.com/locations/ar/little-rock/little-rock/2057?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:little-rock-ar-2057_pl:locurl_rd:1049",
      "poi_directions_map_url": "https://maps.google.com/?cid=3472249337757460353&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "34.7490565",
      "poi_longitude": "-92.3416523",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 501-614-7578",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8478-70aa-accf-f1328dcb22c8",
        "storage_key": "property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJve0we4Ck0ocRgWeePGDoLzA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_60b5207b-83f6-4ddd-ba8b-f31d94c1cbcf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Tropical Smoothie Cafe",
      "poi_type": "Restaurants",
      "poi_address": "410 S University Ave Suite 140, Little Rock, AR 72205, USA",
      "poi_short_description": "Health-conscious cafe chain featuring a menu of custom smoothies, sandwiches & wraps.",
      "poi_long_description": "Health-conscious cafe chain featuring a menu of custom smoothies, sandwiches & wraps.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-cb39-7352-aec1-589d27e786ba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-cb39-7352-aec1-589d27e786ba",
        "storage_key": "property/6737460151192619/019e1e0b-cb39-7352-aec1-589d27e786ba.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "https://locations.tropicalsmoothiecafe.com/ar/little-rock/410-s.-university-avenue?y_source=1_MTA5MDM2NzYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6701510571726917968&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tropical-smoothie-cafe",
      "poi_latitude": "34.749424",
      "poi_longitude": "-92.3426",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 501-280-9988",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8478-70aa-accf-f1328dcb22c8",
        "storage_key": "property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp80xe4Ck0ocRUNFO3luMAF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "juice_shop"
    },
    {
      "id": "custom_d445cd45-b259-4d5e-81c2-fb3864b23b87",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "100 S University Ave, Little Rock, AR 72205, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-ceca-740d-8553-26fa681523a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-ceca-740d-8553-26fa681523a3",
        "storage_key": "property/6737460151192619/019e1e0b-ceca-740d-8553-26fa681523a3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.chipotle.com/ar/little-rock/100-s-university-ave?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=2057",
      "poi_directions_map_url": "https://maps.google.com/?cid=8474973575401961572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "34.7520104",
      "poi_longitude": "-92.3415318",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-404-2557",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8478-70aa-accf-f1328dcb22c8",
        "storage_key": "property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7Qk3_3-j0ocRZPingpAnnXU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_4b9572b8-4c28-45c3-9fc3-1df1ea33d1c2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "IHOP",
      "poi_type": "Restaurants",
      "poi_address": "101 N University Ave, Little Rock, AR 72205, USA",
      "poi_short_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_long_description": "Long-standing chain serving a wide variety of pancakes & other American breakfast & diner fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-ca99-7430-87b0-dc024f186c5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-ca99-7430-87b0-dc024f186c5f",
        "storage_key": "property/6737460151192619/019e1e0b-ca99-7430-87b0-dc024f186c5f.webp",
        "width": 1280,
        "height": 847
      },
      "poi_business_url": "https://restaurants.ihop.com/en-us/ar/little-rock/breakfast-101-n.-university-ave-436?utm_source=google&utm_medium=organic&utm_campaign=google_my_business&utm_term=436&utm_content=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=7296685316801159261&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ihop",
      "poi_latitude": "34.75248",
      "poi_longitude": "-92.3407417",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-664-2014",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8478-70aa-accf-f1328dcb22c8",
        "storage_key": "property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjw-txX-j0ocRXeC92aIIQ2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_d3101e2b-1f43-451c-89c1-4fc2768b704f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Doughboy Donuts",
      "poi_type": "Restaurants",
      "poi_address": "2900 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "Casual spot for familiar donuts and kolaches, plus tacos and breakfast biscuits.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-c91c-7550-b080-648bcc787eb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-c91c-7550-b080-648bcc787eb7",
        "storage_key": "property/6737460151192619/019e1e0b-c91c-7550-b080-648bcc787eb7.webp",
        "width": 645,
        "height": 403
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8780664075893689249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "doughboy-donuts",
      "poi_latitude": "34.7262048",
      "poi_longitude": "-92.3425613",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-812-3928",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8478-70aa-accf-f1328dcb22c8",
        "storage_key": "property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJySYtV_il0ocRoUutf3Qv23k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "custom_ac13523f-6004-4c05-8b73-c097e675265f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "The Root Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1500 Main St, Little Rock, AR 72202, USA",
      "poi_short_description": "Chill cafe with a patio offering sandwiches & salads made with locally sourced ingredients.",
      "poi_long_description": "Chill cafe with a patio offering sandwiches & salads made with locally sourced ingredients.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-41b2-760c-bcc5-085fb78f1300.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e09-41b2-760c-bcc5-085fb78f1300",
        "storage_key": "property/6737460151192619/019e1e09-41b2-760c-bcc5-085fb78f1300.webp",
        "width": 1277,
        "height": 473
      },
      "poi_business_url": "http://www.therootcafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2097092921480150968&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-root-cafe",
      "poi_latitude": "34.7342088",
      "poi_longitude": "-92.2735047",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-414-0423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8478-70aa-accf-f1328dcb22c8",
        "storage_key": "property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg0GAiG270ocRuH_PteZeGh0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_9bca9d2f-74dd-4e37-a721-e247928b0cfa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Raduno | Brick Oven & Barroom",
      "poi_type": "Restaurants",
      "poi_address": "1318 S Main St Suite 100, Little Rock, AR 72202, USA",
      "poi_short_description": "Pizza & an Italian-inspired menu with banquette & bar seating in a relaxed, family-friendly setting.",
      "poi_long_description": "Pizza & an Italian-inspired menu with banquette & bar seating in a relaxed, family-friendly setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-cb57-7131-be99-1a8e7c010ffd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-cb57-7131-be99-1a8e7c010ffd",
        "storage_key": "property/6737460151192619/019e1e0b-cb57-7131-be99-1a8e7c010ffd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://radunolr.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17346456726356156823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "raduno--brick-oven--barroom",
      "poi_latitude": "34.7358004",
      "poi_longitude": "-92.2731378",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-374-7476",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8478-70aa-accf-f1328dcb22c8",
        "storage_key": "property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ22_QB3K70ocRl-Ektnz-uvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_db20fa13-0e87-464d-8d1b-2fcf7c1d60e0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Flying Fish",
      "poi_type": "Restaurants",
      "poi_address": "511 President Clinton Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "Laid-back eatery serving seafood with a Cajun twist, from fried catfish to po' boy sandwiches.",
      "poi_long_description": "Laid-back eatery serving seafood with a Cajun twist, from fried catfish to po' boy sandwiches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-c951-776c-84bd-52d1b1b71a00.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-c951-776c-84bd-52d1b1b71a00",
        "storage_key": "property/6737460151192619/019e1e0b-c951-776c-84bd-52d1b1b71a00.webp",
        "width": 1071,
        "height": 573
      },
      "poi_business_url": "https://www.flyingfishinthe.net/little-rock/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15399250899550809109&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flying-fish",
      "poi_latitude": "34.7471349",
      "poi_longitude": "-92.265086",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-375-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8478-70aa-accf-f1328dcb22c8",
        "storage_key": "property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2ZJE1Hi70ocRFSzXuhohtdU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "custom_9d4fdf68-9d24-4d1e-a399-92616763e13a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Wright’s Barbecue - Little Rock",
      "poi_type": "Restaurants",
      "poi_address": "1311 Rebsamen Park Rd, Little Rock, AR 72202, USA",
      "poi_short_description": "Barbecue joint with pit-smoked meats, classic sides and kid-friendly fare, plus a bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-438e-71d3-a6ee-383b906fd833.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e09-438e-71d3-a6ee-383b906fd833",
        "storage_key": "property/6737460151192619/019e1e09-438e-71d3-a6ee-383b906fd833.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://wrightsbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10220360340616443948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wrights-barbecue---little-rock",
      "poi_latitude": "34.7624075",
      "poi_longitude": "-92.3090798",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-441-5774",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8478-70aa-accf-f1328dcb22c8",
        "storage_key": "property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr_6VONuj0ocRLPjuepQD1o0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_936637b0-bba1-4825-a292-fc8d011b85d6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "El Sur Street Food Co",
      "poi_type": "Restaurants",
      "poi_address": "1214 Main St, Little Rock, AR 72202, USA",
      "poi_short_description": "Relaxed venue offering Honduran eats, plus games such as ping pong, pool and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-cd94-72ac-94e6-5f4ba6ac0059.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-cd94-72ac-94e6-5f4ba6ac0059",
        "storage_key": "property/6737460151192619/019e1e0b-cd94-72ac-94e6-5f4ba6ac0059.webp",
        "width": 1280,
        "height": 806
      },
      "poi_business_url": "http://www.elsurstreetfoodco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7828488338912195401&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-sur-street-food-co",
      "poi_latitude": "34.7367753",
      "poi_longitude": "-92.2729262",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-812-3066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8478-70aa-accf-f1328dcb22c8",
        "storage_key": "property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkZHYwlu70ocRSTMmyapgpGw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7095adb6-501b-4100-b1f6-b953580c1b2d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Petit & Keet",
      "poi_type": "Restaurants",
      "poi_address": "1620 Market St, Little Rock, AR 72211, USA",
      "poi_short_description": "Bright, rustic-chic locale with a stylish outdoor lounge, serving refined American eats & cocktails.",
      "poi_long_description": "Bright, rustic-chic locale with a stylish outdoor lounge, serving refined American eats & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-d241-7728-a2d2-5cb814d64c95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-d241-7728-a2d2-5cb814d64c95",
        "storage_key": "property/6737460151192619/019e1e0b-d241-7728-a2d2-5cb814d64c95.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.petitandkeet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15841735986630135196&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petit--keet",
      "poi_latitude": "34.769482",
      "poi_longitude": "-92.398466",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-319-7675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8478-70aa-accf-f1328dcb22c8",
        "storage_key": "property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJd47OA0Gh0ocRnI2cXPIm2ds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_05bdac81-3045-4efc-bcb7-d6315c632b2c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "416 S University Ave #100, Little Rock, AR 72205, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-d6f3-73e9-a626-5d999fadc470.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-d6f3-73e9-a626-5d999fadc470",
        "storage_key": "property/6737460151192619/019e1e0b-d6f3-73e9-a626-5d999fadc470.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "https://locations.dollartree.com/ar/little-rock/416-s-university-suite-100?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9933993129289326097&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "34.7493813",
      "poi_longitude": "-92.3432222",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 501-243-0696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848b-7349-b899-7a652550c217.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848b-7349-b899-7a652550c217",
        "storage_key": "property/6737460151192619/019e1e09-848b-7349-b899-7a652550c217.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZezjs--l0ocRER52WB6i3Ik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_9cb35c72-db4d-486a-b0a2-d239a78eaa23",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Five Below",
      "poi_type": "Shopping & Retail",
      "poi_address": "416 S University Ave Suite 105, Little Rock, AR 72205, USA",
      "poi_short_description": "Teen-oriented retail chain for a large assortment of games, snacks, jewelry, room decor & more.",
      "poi_long_description": "Teen-oriented retail chain for a large assortment of games, snacks, jewelry, room decor & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-d640-74f8-a22d-1c0b59a90695.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-d640-74f8-a22d-1c0b59a90695",
        "storage_key": "property/6737460151192619/019e1e0b-d640-74f8-a22d-1c0b59a90695.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.fivebelow.com/ar/little-rock/416-s-university-avenue?utm_source=gmb&utm_medium=yext&y_source=1_ODAyMjYzODQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10102309275543937921&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-below",
      "poi_latitude": "34.749463",
      "poi_longitude": "-92.343523",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 501-287-5152",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848b-7349-b899-7a652550c217.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848b-7349-b899-7a652550c217",
        "storage_key": "property/6737460151192619/019e1e09-848b-7349-b899-7a652550c217.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJtbCZaxGl0ocRgSPuA8OcMow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_d69aebe9-37cb-4d07-b266-43cd3ea2ec11",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "T-Mobile Experience Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "410 S University Ave #100, Little Rock, AR 72205, USA",
      "poi_short_description": "Wireless provider offering cell phones, data plans, Internet devices & accessories.",
      "poi_long_description": "Wireless provider offering cell phones, data plans, Internet devices & accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-de73-7462-a42e-3180ffbca4bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-de73-7462-a42e-3180ffbca4bc",
        "storage_key": "property/6737460151192619/019e1e0b-de73-7462-a42e-3180ffbca4bc.webp",
        "width": 1280,
        "height": 725
      },
      "poi_business_url": "https://www.t-mobile.com/stores/bd/t-mobile-little-rock-ar-72205-3sje?utm_source=google&utm_medium=lastmile&utm_campaign=3SJE",
      "poi_directions_map_url": "https://maps.google.com/?cid=17112539694388398776&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "t-mobile-experience-store",
      "poi_latitude": "34.7493878",
      "poi_longitude": "-92.3424072",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 501-219-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848b-7349-b899-7a652550c217.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848b-7349-b899-7a652550c217",
        "storage_key": "property/6737460151192619/019e1e09-848b-7349-b899-7a652550c217.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJe5MGkoil0ocRuMrKmC_0e-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cell_phone_store"
    },
    {
      "id": "custom_98b41612-9245-4a2a-b962-a9c8f962b95b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "3710 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-d6a3-7075-9f03-36aeb2561d89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-d6a3-7075-9f03-36aeb2561d89",
        "storage_key": "property/6737460151192619/019e1e0b-d6a3-7075-9f03-36aeb2561d89.webp",
        "width": 1280,
        "height": 1258
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3710+s+university+ave-little+rock-ar-72204/id=5730",
      "poi_directions_map_url": "https://maps.google.com/?cid=9471439658678270218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "34.7182761",
      "poi_longitude": "-92.3426533",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-568-1486",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0c-1c6a-75fc-8197-360f1ed2ae02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-1c6a-75fc-8197-360f1ed2ae02",
        "storage_key": "property/6737460151192619/019e1e0c-1c6a-75fc-8197-360f1ed2ae02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ97rR9Vek0ocRCrkQDzBQcYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_c72da49b-88f9-4cfb-aca6-4b79150b8271",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "Village Shp Ctr, 3901 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-da34-7119-9ec4-0d20d6297e5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-da34-7119-9ec4-0d20d6297e5f",
        "storage_key": "property/6737460151192619/019e1e0b-da34-7119-9ec4-0d20d6297e5f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.familydollar.com/ar/little-rock/3901-s-university-ave?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5488821317847171120&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "34.7153617",
      "poi_longitude": "-92.3405452",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-214-1071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848b-7349-b899-7a652550c217.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848b-7349-b899-7a652550c217",
        "storage_key": "property/6737460151192619/019e1e09-848b-7349-b899-7a652550c217.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvyR541ek0ocRMEDfVeg1LEw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_94cdfd58-7a07-440f-8607-35a98cfae6ee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Harbor Freight",
      "poi_type": "Shopping & Retail",
      "poi_address": "3901 S University Ave Suite 6, Little Rock, AR 72204, USA",
      "poi_short_description": "Retail chain carrying a wide range of tools, hardware & other products for the home, garden & car.",
      "poi_long_description": "Retail chain carrying a wide range of tools, hardware & other products for the home, garden & car.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-dace-774a-b092-c2379dc20eaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-dace-774a-b092-c2379dc20eaa",
        "storage_key": "property/6737460151192619/019e1e0b-dace-774a-b092-c2379dc20eaa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.harborfreight.com/storelocator/3901-s-university-ave-suite-6-little-rock-72204?number=94",
      "poi_directions_map_url": "https://maps.google.com/?cid=2489223852879671903&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harbor-freight",
      "poi_latitude": "34.7159843",
      "poi_longitude": "-92.3406219",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-562-6262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848b-7349-b899-7a652550c217.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848b-7349-b899-7a652550c217",
        "storage_key": "property/6737460151192619/019e1e09-848b-7349-b899-7a652550c217.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5YcVB_ik0ocRX3JS3ed_iyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hardware_store"
    },
    {
      "id": "custom_be746a04-13c1-496f-9727-ce6b1d65acc7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "dd's DISCOUNTS",
      "poi_type": "Shopping & Retail",
      "poi_address": "3901 S University Ave STE 20, Little Rock, AR 72204, USA",
      "poi_short_description": "Retail chain stocking discounted clothing & shoes for adults or kids, plus home decor.",
      "poi_long_description": "Retail chain stocking discounted clothing & shoes for adults or kids, plus home decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-de21-70ff-9e82-f475b1f678e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-de21-70ff-9e82-f475b1f678e0",
        "storage_key": "property/6737460151192619/019e1e0b-de21-70ff-9e82-f475b1f678e0.webp",
        "width": 1196,
        "height": 673
      },
      "poi_business_url": "https://www.ddsdiscounts.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10818727521364414528&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dds-discounts",
      "poi_latitude": "34.7148475",
      "poi_longitude": "-92.3405456",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-569-9886",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848b-7349-b899-7a652550c217.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848b-7349-b899-7a652550c217",
        "storage_key": "property/6737460151192619/019e1e09-848b-7349-b899-7a652550c217.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJg1Y9k_ik0ocRQBCrUFzXI5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_3a8a1bf0-3137-4d0a-a0fa-7806df51cf4c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Mr. Chen’s Oriental Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "3901 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "Sprawling market selling groceries from China and other Asian countries along with produce.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-dfa2-77dc-b0e8-a5f20ff6a8ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-dfa2-77dc-b0e8-a5f20ff6a8ed",
        "storage_key": "property/6737460151192619/019e1e0b-dfa2-77dc-b0e8-a5f20ff6a8ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://usmapz.me/mr-chen-s-oriental-supermarket-886849-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=4811636863940915708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mr-chens-oriental-supermarket",
      "poi_latitude": "34.7156583",
      "poi_longitude": "-92.3405667",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-562-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-858e-7455-948a-050446066d68.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-858e-7455-948a-050446066d68",
        "storage_key": "property/6737460151192619/019e1e09-858e-7455-948a-050446066d68.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRyV541ek0ocR_HFfDzxexkI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_26bb4fa3-8e64-4f47-b17a-2d4dc6a4e305",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Pulaski Heights Elementary School",
      "poi_type": "Education",
      "poi_address": "319 N Pine St, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lrsd.org/o/phes",
      "poi_directions_map_url": "https://maps.google.com/?cid=7687414638521500169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pulaski-heights-elementary-school",
      "poi_latitude": "34.7541572",
      "poi_longitude": "-92.3160076",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-447-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8680-701f-913a-ceba42aa7778",
        "storage_key": "property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ9TM13Vij0ocRCUI2UuIur2o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f80dd8ed-5e0e-4d07-83fc-dc68cb87829e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Pulaski Heights Middle School",
      "poi_type": "Education",
      "poi_address": "401 N Pine St, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lrsd.org/o/phms",
      "poi_directions_map_url": "https://maps.google.com/?cid=12058266796524661434&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pulaski-heights-middle-school",
      "poi_latitude": "34.7549337",
      "poi_longitude": "-92.3159845",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-447-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8680-701f-913a-ceba42aa7778",
        "storage_key": "property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJP81l4Fij0ocRumq9lcORV6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e46428e9-d7c6-40db-8bda-04967090e259",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "School",
      "poi_type": "Education",
      "poi_address": "6700 H St, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.lrsdhallhigh.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9077590077404740908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "school",
      "poi_latitude": "34.7605212",
      "poi_longitude": "-92.3474361",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-447-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8680-701f-913a-ceba42aa7778",
        "storage_key": "property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJd2JinYSj0ocRLP1RjBQU-n0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_4f7b0e05-b244-46ba-9267-19a02561b9a4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "ASBVI",
      "poi_type": "Education",
      "poi_address": "2600 W Markham St, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.arkansasschoolfortheblind.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9773804190558908691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asbvi",
      "poi_latitude": "34.7526315",
      "poi_longitude": "-92.3031477",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-296-1810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8680-701f-913a-ceba42aa7778",
        "storage_key": "property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjb9Nvn2j0ocRE_F8oiCHo4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e6cb4a8b-1fc1-4f9d-95be-f15673478af0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Arkansas School for the Deaf",
      "poi_type": "Education",
      "poi_address": "2400 W Markham St, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-e009-7529-bcfd-6b21595a8cb7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-e009-7529-bcfd-6b21595a8cb7",
        "storage_key": "property/6737460151192619/019e1e0b-e009-7529-bcfd-6b21595a8cb7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://asd.ade.arkansas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8427095790466669486&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-school-for-the-deaf",
      "poi_latitude": "34.7515916",
      "poi_longitude": "-92.2978221",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-324-9506",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8680-701f-913a-ceba42aa7778",
        "storage_key": "property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLcFNx1W70ocRrpv0BvkO83Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_1f7d49cb-4ad0-46e4-b19f-9163613c9843",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Children's House Montessori",
      "poi_type": "Education",
      "poi_address": "4023 Lee Ave, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-e4a4-723f-8262-0a13947e87db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-e4a4-723f-8262-0a13947e87db",
        "storage_key": "property/6737460151192619/019e1e0b-e4a4-723f-8262-0a13947e87db.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://chmlr.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18419873156770953469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-house-montessori",
      "poi_latitude": "34.7550275",
      "poi_longitude": "-92.3181109",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-664-5993",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8680-701f-913a-ceba42aa7778",
        "storage_key": "property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH5ah1F6j0ocR_fgVHQuJoP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_171fd26d-e6f8-4664-b565-4744a7d116e9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Catholic High School for Boys",
      "poi_type": "Education",
      "poi_address": "6300 Father Tribou St, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-e37d-71f8-9d56-964a8a0bd399.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-e37d-71f8-9d56-964a8a0bd399",
        "storage_key": "property/6737460151192619/019e1e0b-e37d-71f8-9d56-964a8a0bd399.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lrchs.org/?utm_source=gbp&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=8424940990777372902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "catholic-high-school-for-boys",
      "poi_latitude": "34.7568934",
      "poi_longitude": "-92.3443285",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-664-3939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8680-701f-913a-ceba42aa7778",
        "storage_key": "property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCXwOl4Gj0ocR5rDpoDFn63Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_3607249a-37fa-495c-8962-6d5b8ae1dfd3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Little Rock Central High School",
      "poi_type": "Education",
      "poi_address": "1500 Little Rock Nine Wy, Little Rock, AR 72202, USA",
      "poi_short_description": "1957 crisis over the desegregation of this school is a significant event in the civil-rights moment.",
      "poi_long_description": "1957 crisis over the desegregation of this school is a significant event in the civil-rights moment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-e3df-72ea-9f4a-071315115d08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-e3df-72ea-9f4a-071315115d08",
        "storage_key": "property/6737460151192619/019e1e0b-e3df-72ea-9f4a-071315115d08.webp",
        "width": 1280,
        "height": 963
      },
      "poi_business_url": "http://lrcentralhigh.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10066891211629443539&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-rock-central-high-school",
      "poi_latitude": "34.7367998",
      "poi_longitude": "-92.2986873",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-447-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8680-701f-913a-ceba42aa7778",
        "storage_key": "property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhw9ziUy70ocR07msZTjItIs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_5c795c9a-1533-44ea-9440-f05f2d8a5289",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Museum of Discovery",
      "poi_type": "Entertainment",
      "poi_address": "500 President Clinton Ave Ste. 150, Little Rock, AR 72201, USA",
      "poi_short_description": "Playful, interactive exhibits exploring scientific concepts at this family-friendly destination.",
      "poi_long_description": "Playful, interactive exhibits exploring scientific concepts at this family-friendly destination.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-e253-75d2-816f-01e976d5330c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-e253-75d2-816f-01e976d5330c",
        "storage_key": "property/6737460151192619/019e1e0b-e253-75d2-816f-01e976d5330c.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "http://www.museumofdiscovery.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16338434694446452897&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-discovery",
      "poi_latitude": "34.7476729",
      "poi_longitude": "-92.2646549",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-396-7050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-84c6-74bf-8def-b9031da0f86a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-84c6-74bf-8def-b9031da0f86a",
        "storage_key": "property/6737460151192619/019e1e09-84c6-74bf-8def-b9031da0f86a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJVUmT0ni70ocRoRBmNMrHveI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1308c11f-23c4-4e3c-a904-bc668590642b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Arkansas Museum of Fine Arts",
      "poi_type": "Entertainment",
      "poi_address": "501 E 9th St, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-e826-70b9-a085-d8c866eaf194.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-e826-70b9-a085-d8c866eaf194",
        "storage_key": "property/6737460151192619/019e1e0b-e826-70b9-a085-d8c866eaf194.webp",
        "width": 1280,
        "height": 686
      },
      "poi_business_url": "https://arkmfa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16794530987996013232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-museum-of-fine-arts",
      "poi_latitude": "34.7380757",
      "poi_longitude": "-92.2660985",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-372-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-84c6-74bf-8def-b9031da0f86a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-84c6-74bf-8def-b9031da0f86a",
        "storage_key": "property/6737460151192619/019e1e09-84c6-74bf-8def-b9031da0f86a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJs9p-Prq70ocRsOLKzPMoEuk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_98a4475b-4833-479d-b661-7c7e343c3cdc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "MacArthur Museum of Arkansas Military History",
      "poi_type": "Entertainment",
      "poi_address": "503 E 9th St, Little Rock, AR 72202, USA",
      "poi_short_description": "The state's military heritage told through rotating exhibits in the birthplace of Douglas MacArthur.",
      "poi_long_description": "The state's military heritage told through rotating exhibits in the birthplace of Douglas MacArthur.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-ea96-757e-85ad-5f3ecb829db4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-ea96-757e-85ad-5f3ecb829db4",
        "storage_key": "property/6737460151192619/019e1e0b-ea96-757e-85ad-5f3ecb829db4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.littlerock.gov/macarthur",
      "poi_directions_map_url": "https://maps.google.com/?cid=13410887565829847636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macarthur-museum-of-arkansas-military-history",
      "poi_latitude": "34.7383187",
      "poi_longitude": "-92.2652979",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-376-4602",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-84c6-74bf-8def-b9031da0f86a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-84c6-74bf-8def-b9031da0f86a",
        "storage_key": "property/6737460151192619/019e1e09-84c6-74bf-8def-b9031da0f86a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJPSOuJne70ocRVLr96y8LHbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_c9c629ac-4e9c-4938-943b-92bd37e14c36",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Robinson Center",
      "poi_type": "Entertainment",
      "poi_address": "426 W Markham St, Little Rock, AR 72201, USA",
      "poi_short_description": "Renovated 1939 theater features an expansive performance space for musicals, plays & more.",
      "poi_long_description": "Renovated 1939 theater features an expansive performance space for musicals, plays & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-e5ca-758f-b956-2ca03146fa09.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-e5ca-758f-b956-2ca03146fa09",
        "storage_key": "property/6737460151192619/019e1e0b-e5ca-758f-b956-2ca03146fa09.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.robinsoncenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15299738811072087964&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robinson-center",
      "poi_latitude": "34.7492294",
      "poi_longitude": "-92.2744598",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-244-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8477-73ef-a30f-2f9b77b1dda0",
        "storage_key": "property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0xGEWO70ocRnIc1HmOXU9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_0473d87f-2ed1-42f3-a4b2-19bdc9402d39",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Ron Robinson Theater -- Central Arkansas Library System",
      "poi_type": "Entertainment",
      "poi_address": "Library Square, 100 River Market Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "Theater (part of the Central Arkansas Library System) equipped for films, concerts, plays and lectures, among other performances.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-ec6b-71fe-8798-c7c2447c266b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-ec6b-71fe-8798-c7c2447c266b",
        "storage_key": "property/6737460151192619/019e1e0b-ec6b-71fe-8798-c7c2447c266b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ronrobinsontheater.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9620992703836030317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ron-robinson-theater----central-arkansas-library-system",
      "poi_latitude": "34.7472238",
      "poi_longitude": "-92.2659196",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-320-5715",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8477-73ef-a30f-2f9b77b1dda0",
        "storage_key": "property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyfNLKHm70ocRbYXF0uOhhIU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_98ae6d28-44ae-4acb-90e3-9892c115f2b7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Old State House Museum",
      "poi_type": "Entertainment",
      "poi_address": "300 W Markham St, Little Rock, AR 72201, USA",
      "poi_short_description": "National Historic Landmark building featuring permanent & traveling exhibits on Arkansas history.",
      "poi_long_description": "National Historic Landmark building featuring permanent & traveling exhibits on Arkansas history.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-eed0-7753-bf24-8b03a1314ffe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-eed0-7753-bf24-8b03a1314ffe",
        "storage_key": "property/6737460151192619/019e1e0b-eed0-7753-bf24-8b03a1314ffe.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.oldstatehouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4679743598728721160&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-state-house-museum",
      "poi_latitude": "34.7490498",
      "poi_longitude": "-92.2725927",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-324-9685",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-84c6-74bf-8def-b9031da0f86a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-84c6-74bf-8def-b9031da0f86a",
        "storage_key": "property/6737460151192619/019e1e09-84c6-74bf-8def-b9031da0f86a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJm453s3y70ocRCDMiOgLK8UA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_fc086d2d-2e9f-4de6-90a3-ef496bbc1fde",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Revolution Music Room (The Rev Room)",
      "poi_type": "Entertainment",
      "poi_address": "300 President Clinton Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "Locally owned venue hosting concerts by diverse performers in an intimate, casual setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-ec84-74ad-a1c8-92922a6e1f6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-ec84-74ad-a1c8-92922a6e1f6f",
        "storage_key": "property/6737460151192619/019e1e0b-ec84-74ad-a1c8-92922a6e1f6f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.revroom.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10306964832580352669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "revolution-music-room-the-rev-room",
      "poi_latitude": "34.7477915",
      "poi_longitude": "-92.2675003",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-823-0090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8477-73ef-a30f-2f9b77b1dda0",
        "storage_key": "property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2ZZLrH670ocRnTplFuixCY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "concert_hall"
    },
    {
      "id": "custom_7683ac19-9bff-40c5-97f5-4f743139b146",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Willy D's Dueling Pianos",
      "poi_type": "Entertainment",
      "poi_address": "322 President Clinton Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "Nightspot featuring a dueling piano show with audience participation, plus beer pong & dancing.",
      "poi_long_description": "Nightspot featuring a dueling piano show with audience participation, plus beer pong & dancing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-f1e6-7485-a2b5-70a071c4134b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-f1e6-7485-a2b5-70a071c4134b",
        "storage_key": "property/6737460151192619/019e1e0b-f1e6-7485-a2b5-70a071c4134b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://willydspianobar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5310474469339430131&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "willy-ds-dueling-pianos",
      "poi_latitude": "34.7477318",
      "poi_longitude": "-92.2669904",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-244-9550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8476-73cd-9837-93ee565d195c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8476-73cd-9837-93ee565d195c",
        "storage_key": "property/6737460151192619/019e1e09-8476-73cd-9837-93ee565d195c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoWJysX670ocR8_zBzWSYskk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_2979d92a-abbf-4437-861e-a445a46b3100",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Little Rock River Market",
      "poi_type": "Entertainment",
      "poi_address": "400 President Clinton Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "Riverside hub with an international food hall, a twice-weekly farmer's market & frequent concerts.",
      "poi_long_description": "Riverside hub with an international food hall, a twice-weekly farmer's market & frequent concerts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-ed8f-7528-9ad1-9ef1d2a0151f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-ed8f-7528-9ad1-9ef1d2a0151f",
        "storage_key": "property/6737460151192619/019e1e0b-ed8f-7528-9ad1-9ef1d2a0151f.webp",
        "width": 640,
        "height": 428
      },
      "poi_business_url": "http://www.rivermarket.info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16636751081372703839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-rock-river-market",
      "poi_latitude": "34.7476319",
      "poi_longitude": "-92.2661051",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-375-2552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8478-70aa-accf-f1328dcb22c8",
        "storage_key": "property/6737460151192619/019e1e09-8478-70aa-accf-f1328dcb22c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMRS8yn670ocRX9zQlfac4eY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "food_court"
    },
    {
      "id": "custom_2d71a165-0df0-4680-9ed5-224762b75438",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "420 S University Ave, Little Rock, AR 72205, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-f05e-76af-9397-41dda1cfc1a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-f05e-76af-9397-41dda1cfc1a5",
        "storage_key": "property/6737460151192619/019e1e0b-f05e-76af-9397-41dda1cfc1a5.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/little-rock-ar-pharmacies/420-s-university-ave-little-rock-ar-72205/storeid=17611?WT.mc_id=LS_GOOGLE_RX_17611",
      "poi_directions_map_url": "https://maps.google.com/?cid=7433760364738060225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "34.7493548",
      "poi_longitude": "-92.3448156",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 501-801-3413",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0c-1c6a-75fc-8197-360f1ed2ae02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-1c6a-75fc-8197-360f1ed2ae02",
        "storage_key": "property/6737460151192619/019e1e0c-1c6a-75fc-8197-360f1ed2ae02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZXmlfICk0ocRwR-XfaoFKmc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_1f958eec-ebf2-4f15-a107-5b8c8500f7d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy at St Vincent's Professional Office Bldg",
      "poi_type": "Health and Wellness",
      "poi_address": "500 S University Ave, Little Rock, AR 72205, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-f2b0-715b-ac2c-19e7f6829572.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-f2b0-715b-ac2c-19e7f6829572",
        "storage_key": "property/6737460151192619/019e1e0b-f2b0-715b-ac2c-19e7f6829572.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-500+s+university+ave-little+rock-ar-72205/id=15714",
      "poi_directions_map_url": "https://maps.google.com/?cid=4440378566260372250&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy-at-st-vincents-professional-office-bldg",
      "poi_latitude": "34.7476202",
      "poi_longitude": "-92.3427862",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 501-664-4121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0c-1c6a-75fc-8197-360f1ed2ae02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-1c6a-75fc-8197-360f1ed2ae02",
        "storage_key": "property/6737460151192619/019e1e0c-1c6a-75fc-8197-360f1ed2ae02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS_PaJH6k0ocRGjM1psdknz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_0106b2e3-b882-48cf-af56-f680af4c2232",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "UAMS Health - Outpatient Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "Outpatient Center First Floor, 4110 Outpatient Cir Suite 1200, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-f2b4-74be-aadc-2932ad876e19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-f2b4-74be-aadc-2932ad876e19",
        "storage_key": "property/6737460151192619/019e1e0b-f2b4-74be-aadc-2932ad876e19.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://uamshealth.com/location/uams-outpatient-pharmacy/?utm_source=google&utm_medium=gmb&utm_campaign=clinical&utm_term=location&utm_content=profile&utm_specs=uams-outpatient-pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=8528228094231673424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uams-health---outpatient-pharmacy",
      "poi_latitude": "34.747922",
      "poi_longitude": "-92.3196915",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-686-5530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0c-1c6a-75fc-8197-360f1ed2ae02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-1c6a-75fc-8197-360f1ed2ae02",
        "storage_key": "property/6737460151192619/019e1e0c-1c6a-75fc-8197-360f1ed2ae02.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWemkWNKl0ocRUHovaERaWnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_4043b271-4f41-4f48-8520-095feafff015",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Genesis Health Clubs - Little Rock Midtown",
      "poi_type": "Health and Wellness",
      "poi_address": "304 S University Ave, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-f1fa-7680-ba19-c35da26e9289.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-f1fa-7680-ba19-c35da26e9289",
        "storage_key": "property/6737460151192619/019e1e0b-f1fa-7680-ba19-c35da26e9289.webp",
        "width": 462,
        "height": 300
      },
      "poi_business_url": "https://www.genesishealthclubs.com/locations/little-rock-midtown.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11377487154629901942&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "genesis-health-clubs---little-rock-midtown",
      "poi_latitude": "34.7507084",
      "poi_longitude": "-92.3424301",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-707-3561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8477-73ef-a30f-2f9b77b1dda0",
        "storage_key": "property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOetrSBGl0ocRdv5IYEn05J0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_bcf28de2-52f8-465d-a082-035115d84736",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "207 N University Ave #180, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-f573-73e2-a787-0c2663a10fcd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-f573-73e2-a787-0c2663a10fcd",
        "storage_key": "property/6737460151192619/019e1e0b-f573-73e2-a787-0c2663a10fcd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.clubpilates.com/littlerockmidtowne/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=12684106234849731541&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "34.7534684",
      "poi_longitude": "-92.3396016",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 501-588-3772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8680-701f-913a-ceba42aa7778",
        "storage_key": "property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJXTU847-j0ocR1SOJ1Wr_BrA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c4ef1036-2703-412e-b905-daf6db35898e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Clubhaus Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1207 Rebsamen Park Rd, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-ffb6-73f8-a10f-a0744234c47d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-ffb6-73f8-a10f-a0744234c47d",
        "storage_key": "property/6737460151192619/019e1e0b-ffb6-73f8-a10f-a0744234c47d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.clubhausfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16353061813937198903&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clubhaus-fitness",
      "poi_latitude": "34.7612471",
      "poi_longitude": "-92.309592",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-916-9587",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8477-73ef-a30f-2f9b77b1dda0",
        "storage_key": "property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjYkJslGj0ocRN1e72RO_8eI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c7c613c4-f81f-4eda-b422-c4a58a879ee6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "The Bernice Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1401 S Main St, Little Rock, AR 72202, USA",
      "poi_short_description": "Peaceful green space for gardens, sculptures, music and farmers markets, featuring festivals and other community events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-f804-77f8-a10e-ce4dbf65795f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-f804-77f8-a10e-ce4dbf65795f",
        "storage_key": "property/6737460151192619/019e1e0b-f804-77f8-a10e-ce4dbf65795f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thebernicegarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1124392713265070932&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bernice-garden",
      "poi_latitude": "34.7350292",
      "poi_longitude": "-92.2725542",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-410-3938",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8477-73ef-a30f-2f9b77b1dda0",
        "storage_key": "property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVYkRCnK70ocRVMMzJjelmg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_e07d6550-6d1c-4205-82ad-e07aaf4c0791",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Julius Breckling Riverfront Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "400 President Clinton Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "Trails & overlooks along the Arkansas River, with playgrounds, historic markers & sculptures.",
      "poi_long_description": "Trails & overlooks along the Arkansas River, with playgrounds, historic markers & sculptures.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-6b87-767c-ab0a-5f3d27a7a44f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e09-6b87-767c-ab0a-5f3d27a7a44f",
        "storage_key": "property/6737460151192619/019e1e09-6b87-767c-ab0a-5f3d27a7a44f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.littlerock.gov/residents/parks-and-recreation/park-facility-trail-information/riverfront/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13698303629607314796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "julius-breckling-riverfront-park",
      "poi_latitude": "34.7484093",
      "poi_longitude": "-92.266912",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848c-75d6-bea5-9182ef94d7d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848c-75d6-bea5-9182ef94d7d1",
        "storage_key": "property/6737460151192619/019e1e09-848c-75d6-bea5-9182ef94d7d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ894yxn670ocRbCUwDJMmGr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e16b48dc-e4a9-439a-a2a1-ca8b04065f9c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "MacArthur Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "601 E 9th St, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-fa71-7423-a04c-c8a519949bde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-fa71-7423-a04c-c8a519949bde",
        "storage_key": "property/6737460151192619/019e1e0b-fa71-7423-a04c-c8a519949bde.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.littlerock.gov/56621",
      "poi_directions_map_url": "https://maps.google.com/?cid=1556842108685982489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macarthur-park",
      "poi_latitude": "34.7394555",
      "poi_longitude": "-92.2652908",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848c-75d6-bea5-9182ef94d7d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848c-75d6-bea5-9182ef94d7d1",
        "storage_key": "property/6737460151192619/019e1e09-848c-75d6-bea5-9182ef94d7d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwa4JqPe70ocRGRuZO6YDmxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_31026a42-677f-4d12-8f2b-6b13b0b068b3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Allsopp Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3700 Cedar Hill Rd, Little Rock, AR 72202, USA",
      "poi_short_description": "Scenic spot with  hiking & biking trails, a pavilion, ball fields, a playground & tennis courts.",
      "poi_long_description": "Scenic spot with  hiking & biking trails, a pavilion, ball fields, a playground & tennis courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-6d64-766d-9e86-924491975eef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e09-6d64-766d-9e86-924491975eef",
        "storage_key": "property/6737460151192619/019e1e09-6d64-766d-9e86-924491975eef.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.littlerock.org/parksrecreation/parks/details.aspx?id=2",
      "poi_directions_map_url": "https://maps.google.com/?cid=11184102650855523637&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "allsopp-park",
      "poi_latitude": "34.7626339",
      "poi_longitude": "-92.3151961",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848c-75d6-bea5-9182ef94d7d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848c-75d6-bea5-9182ef94d7d1",
        "storage_key": "property/6737460151192619/019e1e09-848c-75d6-bea5-9182ef94d7d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJb9BGskKj0ocRNYW_4xrqNZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1e40b01d-adb6-41f2-920f-bcf85eace1bd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Rebsamen Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3400 Rebsamen Park Rd, Little Rock, AR 72202, USA",
      "poi_short_description": "Public course featuring the scenic Arkansas River, plus a playground and fishing docks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-f953-742f-b14c-e7ab9b22551f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-f953-742f-b14c-e7ab9b22551f",
        "storage_key": "property/6737460151192619/019e1e0b-f953-742f-b14c-e7ab9b22551f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.littlerock.gov/residents/parks-and-recreation/city-park-information/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5159628512088809155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rebsamen-park",
      "poi_latitude": "34.7811349",
      "poi_longitude": "-92.316",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848c-75d6-bea5-9182ef94d7d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848c-75d6-bea5-9182ef94d7d1",
        "storage_key": "property/6737460151192619/019e1e09-848c-75d6-bea5-9182ef94d7d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wCsMTyj0ocRw94HfMuumkc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_55a6da06-3914-4837-8ba5-29f46122655e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Murray Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5900 Rebsamen Park Rd, Little Rock, AR 72202, USA",
      "poi_short_description": "Outdoor venue offering a playground, volleyball court, and picnic and barbecue areas, plus boat ramps.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-6a9b-71cd-82db-80c8fecc004c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e09-6a9b-71cd-82db-80c8fecc004c",
        "storage_key": "property/6737460151192619/019e1e09-6a9b-71cd-82db-80c8fecc004c.webp",
        "width": 1200,
        "height": 675
      },
      "poi_business_url": "https://www.littlerock.gov/56622",
      "poi_directions_map_url": "https://maps.google.com/?cid=13425768046898910529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "murray-park",
      "poi_latitude": "34.7856017",
      "poi_longitude": "-92.3351056",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848c-75d6-bea5-9182ef94d7d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848c-75d6-bea5-9182ef94d7d1",
        "storage_key": "property/6737460151192619/019e1e09-848c-75d6-bea5-9182ef94d7d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6TWwWA-j0ocRQRUz6OfoUbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ca2d8324-e230-4030-86d8-9885d51d0537",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Big Dam Bridge",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4000 Cooks Lndg Rd, North Little Rock, AR 72118, USA",
      "poi_short_description": "The longest U.S. pedestrian & bike bridge (4,226 feet), spanning the Arkansas River atop Murray Dam.",
      "poi_long_description": "The longest U.S. pedestrian & bike bridge (4,226 feet), spanning the Arkansas River atop Murray Dam.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-fa1c-77e4-8ea0-19c163b298f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-fa1c-77e4-8ea0-19c163b298f6",
        "storage_key": "property/6737460151192619/019e1e0b-fa1c-77e4-8ea0-19c163b298f6.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17869723390477343867&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-dam-bridge",
      "poi_latitude": "34.7925668",
      "poi_longitude": "-92.3584127",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8477-73ef-a30f-2f9b77b1dda0",
        "storage_key": "property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp7GbOUyi0ocRexzk674C_vc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bridge"
    },
    {
      "id": "custom_41d428df-1472-496a-be52-f6ca6a5d6058",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Two Rivers Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "RH6X+QC, 6900 Two Rivers Park Road, Little Rock, AR 72223, USA",
      "poi_short_description": "Natural area with bike paths, picnic tables, a playground, and trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-6971-767b-b891-f930af16f1d4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e09-6971-767b-b891-f930af16f1d4",
        "storage_key": "property/6737460151192619/019e1e09-6971-767b-b891-f930af16f1d4.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://pulaskicounty.net/two-rivers-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3852413415211130700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "two-rivers-park",
      "poi_latitude": "34.8114881",
      "poi_longitude": "-92.4017327",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848c-75d6-bea5-9182ef94d7d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848c-75d6-bea5-9182ef94d7d1",
        "storage_key": "property/6737460151192619/019e1e09-848c-75d6-bea5-9182ef94d7d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJy13IPpah0ocRTN-bFZeFdjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d9678e19-9e0e-4d57-8fd5-99f4f14bf059",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "War Memorial Park Pavilion",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5101 W Markham St, Little Rock, AR 72205, USA",
      "poi_short_description": "Playground at a large park with a splash pad, fishing and more, plus a duck-filled pond.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0c-0194-76da-951a-293653c67d71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0c-0194-76da-951a-293653c67d71",
        "storage_key": "property/6737460151192619/019e1e0c-0194-76da-951a-293653c67d71.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.littlerock.gov/residents/parks-and-recreation/park-facility-trail-information/war-memorial-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9524645112464390772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "war-memorial-park-pavilion",
      "poi_latitude": "34.7498923",
      "poi_longitude": "-92.3341988",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-371-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848c-75d6-bea5-9182ef94d7d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848c-75d6-bea5-9182ef94d7d1",
        "storage_key": "property/6737460151192619/019e1e09-848c-75d6-bea5-9182ef94d7d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWz5ZfYKk0ocRdLoZHERWLoQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9f2d2e34-8af4-48c8-af4f-db42694c9de5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Pinnacle Mountain State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9600 AR-300, Little Rock, AR 72223, USA",
      "poi_short_description": "Expansive park provides hiking trails with mountain vistas, canoeing, a visitor center & arboretum.",
      "poi_long_description": "Expansive park provides hiking trails with mountain vistas, canoeing, a visitor center & arboretum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-fe1c-7528-b017-052b712fa8d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-fe1c-7528-b017-052b712fa8d0",
        "storage_key": "property/6737460151192619/019e1e0b-fe1c-7528-b017-052b712fa8d0.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "http://www.arkansasstateparks.com/pinnaclemountain/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7415151776586774696&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinnacle-mountain-state-park",
      "poi_latitude": "34.8366143",
      "poi_longitude": "-92.4710906",
      "poi_miles_from_property": "12.1",
      "poi_walking_minutes": "4 hours 26 mins",
      "poi_biking_minutes": "1 hour 21 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 501-868-5806",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848c-75d6-bea5-9182ef94d7d1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848c-75d6-bea5-9182ef94d7d1",
        "storage_key": "property/6737460151192619/019e1e09-848c-75d6-bea5-9182ef94d7d1.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJsU_2JeNfzYcRqLgP70Dp52Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_9d1d812e-adca-4f14-b05c-5413c34a028f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "River Cities Travel Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "310 E Capitol Ave, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0c-025b-7739-80c4-1578b2ce18e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0c-025b-7739-80c4-1578b2ce18e6",
        "storage_key": "property/6737460151192619/019e1e0c-025b-7739-80c4-1578b2ce18e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rrmetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3809342745980765106&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-cities-travel-center",
      "poi_latitude": "34.7442945",
      "poi_longitude": "-92.2680391",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8477-73ef-a30f-2f9b77b1dda0",
        "storage_key": "property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuazOJHq70ocRsgPlcQuB3TQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_f126651a-c556-4ced-b589-0a522bc0a4a8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Union Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1400 W Markham St, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-727b-76f8-ba01-33eca69ebe48.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e09-727b-76f8-ba01-33eca69ebe48",
        "storage_key": "property/6737460151192619/019e1e09-727b-76f8-ba01-33eca69ebe48.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=LRK",
      "poi_directions_map_url": "https://maps.google.com/?cid=16485565726769375602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "union-station",
      "poi_latitude": "34.750483",
      "poi_longitude": "-92.28700990000002",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-88c4-7729-9791-438ec5382f01.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-88c4-7729-9791-438ec5382f01",
        "storage_key": "property/6737460151192619/019e1e09-88c4-7729-9791-438ec5382f01.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ55EYqF-70ocRcmlxKa9-yOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_01c81793-0fec-4f64-a658-087c8fa363a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Bill and Hillary Clinton National Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Airport Rd, Little Rock, AR 72202, USA",
      "poi_short_description": "Airport in former President Clinton's prior hometown, featuring a host of domestic flights.",
      "poi_long_description": "Airport in former President Clinton's prior hometown, featuring a host of domestic flights.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0c-05d8-704b-a5a3-70d7ca6c5d45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0c-05d8-704b-a5a3-70d7ca6c5d45",
        "storage_key": "property/6737460151192619/019e1e0c-05d8-704b-a5a3-70d7ca6c5d45.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.clintonairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7788752853462898252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bill-and-hillary-clinton-national-airport",
      "poi_latitude": "34.7315031",
      "poi_longitude": "-92.2233332",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 501-372-3439",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0c-1c6b-77ac-9829-1fb44c29521f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e0c-1c6b-77ac-9829-1fb44c29521f",
        "storage_key": "property/6737460151192619/019e1e0c-1c6b-77ac-9829-1fb44c29521f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1eIlS2C50ocRTFb3IXQ1F2w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_7431a2c6-e4b5-49a7-88cf-b5728944a1f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "River Market & Pres Clinton Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0c-068f-732f-967d-19f54af19216.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0c-068f-732f-967d-19f54af19216",
        "storage_key": "property/6737460151192619/019e1e0c-068f-732f-967d-19f54af19216.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8584000391786929158&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "river-market--pres-clinton-ave",
      "poi_latitude": "34.747178",
      "poi_longitude": "-92.265628",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8477-73ef-a30f-2f9b77b1dda0",
        "storage_key": "property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCy-bKXm70ocRBhxGWOB-IHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_c9927a82-9350-4776-8937-556d9d8b2108",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Transportation & Transit",
      "poi_address": "420 S University Ave, Little Rock, AR 72205, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-d301-774d-9acc-6b92887ccd3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-d301-774d-9acc-6b92887ccd3c",
        "storage_key": "property/6737460151192619/019e1e0b-d301-774d-9acc-6b92887ccd3c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.target.com/sl/little-rock-univer/2737",
      "poi_directions_map_url": "https://maps.google.com/?cid=9354354159152902029&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "34.749465",
      "poi_longitude": "-92.3449331",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 501-801-3412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848b-7349-b899-7a652550c217.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848b-7349-b899-7a652550c217",
        "storage_key": "property/6737460151192619/019e1e09-848b-7349-b899-7a652550c217.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZXmlfICk0ocRja-B14tX0YE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_18b056e9-88ef-4df4-b4ea-0fc1b1ce17a6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Metro by T-Mobile",
      "poi_type": "Transportation & Transit",
      "poi_address": "1608 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "Wireless provider supplying phones, tablets & accessories, plus cell phone & device data plans.",
      "poi_long_description": "Wireless provider supplying phones, tablets & accessories, plus cell phone & device data plans.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0c-0970-70b3-8ded-5df277f21da6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0c-0970-70b3-8ded-5df277f21da6",
        "storage_key": "property/6737460151192619/019e1e0c-0970-70b3-8ded-5df277f21da6.webp",
        "width": 1088,
        "height": 603
      },
      "poi_business_url": "https://www.metrobyt-mobile.com/stores/bd/metro-by-t-mobile-little-rock-ar-10314874/?utm_source=google&utm_medium=lastmile&utm_campaign=35756",
      "poi_directions_map_url": "https://maps.google.com/?cid=6432170559144894599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metro-by-t-mobile",
      "poi_latitude": "34.73757250000001",
      "poi_longitude": "-92.3420131",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 501-251-1127",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848b-7349-b899-7a652550c217.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848b-7349-b899-7a652550c217",
        "storage_key": "property/6737460151192619/019e1e09-848b-7349-b899-7a652550c217.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxW0Yf2Kk0ocRh6COYAupQ1k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cell_phone_store"
    },
    {
      "id": "custom_767d8314-0d40-4495-9da3-1f09266e8126",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Greyhound: Bus Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "2 World Ave, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0c-08ab-77c4-9d35-a091c92dcc35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0c-08ab-77c4-9d35-a091c92dcc35",
        "storage_key": "property/6737460151192619/019e1e0c-08ab-77c4-9d35-a091c92dcc35.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.greyhound.com/?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=8801926884858579282&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-stop",
      "poi_latitude": "34.7449296",
      "poi_longitude": "-92.2586711",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8477-73ef-a30f-2f9b77b1dda0",
        "storage_key": "property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFdDywoG80ocRUsn0_t25Jno",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_feaeed1b-4f5a-4990-9f12-26edb149756a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Rock Region METRO",
      "poi_type": "Transportation & Transit",
      "poi_address": "901 Maple St, North Little Rock, AR 72114, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0c-0ae4-75f8-bec0-d16f0a6cedbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0c-0ae4-75f8-bec0-d16f0a6cedbb",
        "storage_key": "property/6737460151192619/019e1e0c-0ae4-75f8-bec0-d16f0a6cedbb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://rrmetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8174036123689371751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rock-region-metro",
      "poi_latitude": "34.7624459",
      "poi_longitude": "-92.2689822",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 501-375-6717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8477-73ef-a30f-2f9b77b1dda0",
        "storage_key": "property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtavgzIW80ocRZ0i37YsCcHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_19963e33-03a3-4fbc-ad07-de448d649863",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "University of Arkansas at Little Rock",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2801 S University Ave, Little Rock, AR 72204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-4a59-709f-a47c-585cfd1f4c23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e09-4a59-709f-a47c-585cfd1f4c23",
        "storage_key": "property/6737460151192619/019e1e09-4a59-709f-a47c-585cfd1f4c23.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ualr.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13912235513023897276&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-arkansas-at-little-rock",
      "poi_latitude": "34.7252717",
      "poi_longitude": "-92.3378705",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-916-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8680-701f-913a-ceba42aa7778",
        "storage_key": "property/6737460151192619/019e1e09-8680-701f-913a-ceba42aa7778.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL_aUdFik0ocRvB5dKX0wEsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_bfc8a000-ea7c-48c2-98e9-4232c9a175bf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "UAMS Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4301 W Markham St, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-64dd-72d1-90d4-262a96f930bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e09-64dd-72d1-90d4-262a96f930bb",
        "storage_key": "property/6737460151192619/019e1e09-64dd-72d1-90d4-262a96f930bb.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://uamshealth.com/location/uams-medical-center/?utm_source=google&utm_medium=gmb&utm_campaign=clinical&utm_term=location&utm_content=profile&utm_specs=uams-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=980427499144927317&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "uams-medical-center",
      "poi_latitude": "34.7493145",
      "poi_longitude": "-92.3205392",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 501-686-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848d-727f-9c40-bceb822bc534.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848d-727f-9c40-bceb822bc534",
        "storage_key": "property/6737460151192619/019e1e09-848d-727f-9c40-bceb822bc534.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJJz5GH8ql0ocRVdiOrp0tmw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_6d9417e5-31ba-4338-bebb-6560f653b25a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Arkansas Children's Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Children's Way, Little Rock, AR 72202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-64d1-763e-803e-33b8530027f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e09-64d1-763e-803e-33b8530027f4",
        "storage_key": "property/6737460151192619/019e1e09-64d1-763e-803e-33b8530027f4.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.archildrens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15800723640570466137&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-childrens-hospital",
      "poi_latitude": "34.7430995",
      "poi_longitude": "-92.2918544",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 501-441-3453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848d-727f-9c40-bceb822bc534.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848d-727f-9c40-bceb822bc534",
        "storage_key": "property/6737460151192619/019e1e09-848d-727f-9c40-bceb822bc534.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJf5Fcp1q70ocRWc9Rbm9yR9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e2955b02-5a24-4a0c-a491-b08f685db246",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Baptist Health Medical Center-Little Rock",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9601 Baptist Health Dr, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0b-ef86-735c-ac27-01b06debeefd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0b-ef86-735c-ac27-01b06debeefd",
        "storage_key": "property/6737460151192619/019e1e0b-ef86-735c-ac27-01b06debeefd.webp",
        "width": 1280,
        "height": 480
      },
      "poi_business_url": "https://www.baptist-health.org/find-care/location/Baptist-Health-Medical-Center-Little-Rock",
      "poi_directions_map_url": "https://maps.google.com/?cid=11761299314245094965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-health-medical-center-little-rock",
      "poi_latitude": "34.7441024",
      "poi_longitude": "-92.3811957",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 501-202-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-848d-727f-9c40-bceb822bc534.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-848d-727f-9c40-bceb822bc534",
        "storage_key": "property/6737460151192619/019e1e09-848d-727f-9c40-bceb822bc534.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_wGQvGm0ocRNc6fimmHOKM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2be18d2c-34b9-44b7-80da-5967b4080880",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Central Arkansas Veterans Healthcare System",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4300 W 7th St, Little Rock, AR 72205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0c-0e6b-7369-91a8-53022df44d66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0c-0e6b-7369-91a8-53022df44d66",
        "storage_key": "property/6737460151192619/019e1e0c-0e6b-7369-91a8-53022df44d66.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.littlerock.va.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10120203959047214337&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-arkansas-veterans-healthcare-system",
      "poi_latitude": "34.7463676",
      "poi_longitude": "-92.3204675",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 501-257-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-891e-7691-8120-f7a4c15a9581.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-891e-7691-8120-f7a4c15a9581",
        "storage_key": "property/6737460151192619/019e1e09-891e-7691-8120-f7a4c15a9581.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8bsxhQOl0ocRAdWCseEvcow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_e5f6f164-5251-4ada-8507-c9114805ecc0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Arkansas State Capitol",
      "poi_type": "Major Employers & Offices",
      "poi_address": "500 Woodlane St, Little Rock, AR 72201, USA",
      "poi_short_description": "Grand state capitol building featuring free guided tours, temporary exhibits & a gift shop.",
      "poi_long_description": "Grand state capitol building featuring free guided tours, temporary exhibits & a gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0c-0e8d-7506-8046-9a282b3aa62a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0c-0e8d-7506-8046-9a282b3aa62a",
        "storage_key": "property/6737460151192619/019e1e0c-0e8d-7506-8046-9a282b3aa62a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.sos.arkansas.gov/state-capitol/state-capitol-tour-information",
      "poi_directions_map_url": "https://maps.google.com/?cid=8612870824380092411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arkansas-state-capitol",
      "poi_latitude": "34.7469598",
      "poi_longitude": "-92.28905",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 501-682-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-891e-7691-8120-f7a4c15a9581.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-891e-7691-8120-f7a4c15a9581",
        "storage_key": "property/6737460151192619/019e1e09-891e-7691-8120-f7a4c15a9581.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlak53Fu70ocR-0-Av2EQh3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_82ce4e4a-1f60-48d6-a76c-36ac66060a32",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Windstream (Kinetic, Wholesale, Enterprise)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4005 N Rodney Parham Rd, Little Rock, AR 72212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0c-0b5a-77bb-a9cd-ad220a6c144f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0c-0b5a-77bb-a9cd-ad220a6c144f",
        "storage_key": "property/6737460151192619/019e1e0c-0b5a-77bb-a9cd-ad220a6c144f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.windstream.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16791035967187703863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "windstream-kinetic-wholesale-enterprise",
      "poi_latitude": "34.7871432",
      "poi_longitude": "-92.3974489",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 877-759-9020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8477-73ef-a30f-2f9b77b1dda0",
        "storage_key": "property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVK6onOh0ocRN9gH2z--Bek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "telecommunications_service_provider"
    },
    {
      "id": "custom_a7a86f27-484c-4cc2-a55a-472f82e0aff1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Dillard's Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 Cantrell Rd, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-6d75-715f-96f2-04740a2b0044.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e09-6d75-715f-96f2-04740a2b0044",
        "storage_key": "property/6737460151192619/019e1e09-6d75-715f-96f2-04740a2b0044.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.dillards.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11049574453805387583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dillards-corporate-office",
      "poi_latitude": "34.75433659999999",
      "poi_longitude": "-92.2878465",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-376-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8477-73ef-a30f-2f9b77b1dda0",
        "storage_key": "property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ96xpTae80ocRPw9NLmz5V5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_40e91b1d-de90-4ee2-ac82-bab6f1f10960",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "Stephens Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "111 Center St, Little Rock, AR 72201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e0c-0e17-74ca-bd3c-17024ffa428c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e0c-0e17-74ca-bd3c-17024ffa428c",
        "storage_key": "property/6737460151192619/019e1e0c-0e17-74ca-bd3c-17024ffa428c.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.stephens.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10642390159901556391&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stephens-inc",
      "poi_latitude": "34.747862",
      "poi_longitude": "-92.272615",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 501-377-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-8477-73ef-a30f-2f9b77b1dda0",
        "storage_key": "property/6737460151192619/019e1e09-8477-73ef-a30f-2f9b77b1dda0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAaNdrHy70ocRp34L8nZdsZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_e0fb630d-420c-407c-a446-8435739a3b0f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "poi_name": "William J. Clinton Library and Museum",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 President Clinton Ave, Little Rock, AR 72201, USA",
      "poi_short_description": "3 floors of exhibits & memorabilia related to Clinton's life & presidency, plus a 30-acre park.",
      "poi_long_description": "3 floors of exhibits & memorabilia related to Clinton's life & presidency, plus a 30-acre park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-4dd6-728c-8602-1f55951daaf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e09-4dd6-728c-8602-1f55951daaf7",
        "storage_key": "property/6737460151192619/019e1e09-4dd6-728c-8602-1f55951daaf7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.clintonpresidentialcenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8035004359637958132&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "william-j-clinton-library-and-museum",
      "poi_latitude": "34.7464097",
      "poi_longitude": "-92.2583824",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 501-370-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-84c6-74bf-8def-b9031da0f86a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e09-84c6-74bf-8def-b9031da0f86a",
        "storage_key": "property/6737460151192619/019e1e09-84c6-74bf-8def-b9031da0f86a.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJcWsmz4O70ocR9H3v0OQRgm8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    }
  ],
  "office_hours": [
    {
      "id": "custom_2121cdbd-47d3-4d3b-b206-e0c8b840007b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_1cc7444e-1e4e-4673-bb7b-911fd7c0679a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_033c2792-e6e6-40c0-9b78-f8f88bac1204",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_62f78b83-ddee-4e70-98e2-c620354278b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_272b44cd-6372-4396-a5d0-f0e514bfee46",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_acb5e9c4-3c78-4438-a8cb-59f95edaa319",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_92673b82-9cee-4ec5-873a-6d4b1d3e27ca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "rating": "5",
      "name": "Mallory Thompson",
      "text": "Office staff and maintenance was so helpful! Helped with all my needs. Highly recommend!",
      "date": "2026-05-01",
      "title": "false"
    },
    {
      "id": "custom_7b31fa33-9b82-44e9-b8d2-90b155c9f446",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "rating": "5",
      "name": "Lindsey York",
      "text": "The maintenance is great and on top of everything and the office staff is very friendly!",
      "date": "2026-05-01",
      "title": "false"
    },
    {
      "id": "custom_6f78657f-523c-4056-ac4d-8d53ccf8e25e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "rating": "5",
      "name": "Emily Tucker",
      "text": "Office staff and maintenance are very helpful! They always help with all my needs great team!",
      "date": "2026-04-24",
      "title": "false"
    },
    {
      "id": "custom_547b673e-288c-44ee-b305-9a06f17c4963",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "rating": "5",
      "name": "Tim Fosters",
      "text": "Ryan is best handy man",
      "date": "2026-04-24",
      "title": "false"
    },
    {
      "id": "custom_68f0234c-09b0-4758-a428-1dae8c21eefd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "rating": "5",
      "name": "Ashley",
      "text": "Love this place! Front office is very friendly and maintenance is amazing! They respond to my work orders very quickly and go above and beyond!",
      "date": "2026-04-03",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_3c861c37-34a8-44cf-b63b-861a822446f6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019e1e09-305a-741e-9447-9f73294d1d5c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1e09-305a-741e-9447-9f73294d1d5c",
        "storage_key": "property/6737460151192619/019e1e09-305a-741e-9447-9f73294d1d5c.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Lobby",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6684cd26779a553882eb1c4b"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993fef-3b7a-7575-b9b8-ad0e0475ca26",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-park-avenue-lofts-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619"
    },
    {
      "lead_collector_id": "019a5029-3b19-7639-ab11-8fcd3c7fd8e1",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-park-avenue-lofts-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-little-rock-ar",
      "search_query": "luxury apartments with pool Little Rock AR",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Little Rock, AR",
      "h2_subtitle": "Discover the finest luxury apartments with a pool in Little Rock. The Park Avenue Lofts offer upscale amenities in a convenient location.",
      "page_copy": "The Park Avenue Lofts redefine upscale living in Little Rock, AR. Nestled in the charming Briarwood neighborhood, these luxury apartments with pool access offer an urban sanctuary. Residents can enjoy their free time lounging by the sparkling pool or take advantage of the modern amenities like a cozy gas fire pit, a Starbucks WiFi café, and a state-of-the-art fitness center.\n\nStep into a world of comfort with hardwood floors and in-unit washers and dryers. Whether you're entertaining in the cabana or relaxing in a corporate suite, The Park Avenue Lofts have crafted every detail for an elevated experience. Book a tour today and see why these apartments are the talk of Pulaski County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019d0784-2fac-7706-9699-aa37df615a58.webp",
      "featured_image_media": {
        "alt_text": "Dining area and kitchen with island seating and modern decor.",
        "public_id": "019d0784-2fac-7706-9699-aa37df615a58",
        "storage_key": "property/6737460151192619/019d0784-2fac-7706-9699-aa37df615a58.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool, Little Rock AR",
      "seo_description": "Explore luxury living at The Park Avenue Lofts with a pool in Little Rock, AR. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-with-dog-park-briarwood",
      "search_query": "pet friendly apartments with dog park Briarwood",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments with Dog Park in Briarwood",
      "h2_subtitle": "Explore pet friendly apartments with a dog park in Briarwood. The Park Avenue Lofts welcome you and your furry friends.",
      "page_copy": "Welcome to The Park Avenue Lofts, where pet friendly apartments with a dog park in Briarwood make life easier for pet owners. Nestled in the heart of Little Rock, AR, these luxurious spaces offer convenience and comfort for both you and your pets. Enjoy strolls through the community or unwind by the stylish gas fire pit.\n\nOur modern amenities include more than just a dog park. Residents love the Starbucks WiFi café, hardwood floors, and in-unit washer/dryer. Spacious floor plans ensure you and your pet have all the room you need. Experience vibrant living with your furry companions at The Park Avenue Lofts. Call today and schedule a visit!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019d0784-2fac-7706-9699-aa37df615a58.webp",
      "featured_image_media": {
        "alt_text": "Dining area and kitchen with island seating and modern decor.",
        "public_id": "019d0784-2fac-7706-9699-aa37df615a58",
        "storage_key": "property/6737460151192619/019d0784-2fac-7706-9699-aa37df615a58.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments with Dog Park, Briarwood",
      "seo_description": "Find a welcoming home at The Park Avenue Lofts, pet-friendly with a dog park in Briarwood, Little Rock, AR. Perfect for you and your furry friend!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "page_item_url": "modern-apartments-in-unit-laundry-pulaski-county",
      "search_query": "modern apartments with in-unit laundry Pulaski County",
      "category": "Amenity",
      "h1_title": "Modern Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover modern apartments with in-unit laundry in Pulaski County. The Park Avenue Lofts offer convenience and contemporary elegance.",
      "page_copy": "The Park Avenue Lofts in Little Rock, AR, present modern apartments with in-unit laundry, perfectly situated in Pulaski County's vibrant Briarwood neighborhood. Our luxurious living spaces feature cutting-edge designs that cater to your contemporary lifestyle.\n\nBeyond the convenience of in-unit laundry, residents enjoy hardwood floors, a cozy gas fire pit, and the community's bustling Starbucks WiFi café. Choose from studio to two-bedroom floor plans, each designed with your comfort in mind. Discover a blend of modern amenities and welcoming community spirit at The Park Avenue Lofts. Schedule your personal tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019d0784-2fac-7706-9699-aa37df615a58.webp",
      "featured_image_media": {
        "alt_text": "Dining area and kitchen with island seating and modern decor.",
        "public_id": "019d0784-2fac-7706-9699-aa37df615a58",
        "storage_key": "property/6737460151192619/019d0784-2fac-7706-9699-aa37df615a58.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with In-Unit Laundry in Pulaski",
      "seo_description": "Live in style at The Park Avenue Lofts. Enjoy modern apartments with in-unit laundry in Pulaski County's Briarwood neighborhood. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "page_item_url": "air-conditioned-lofts-downtown-little-rock",
      "search_query": "air conditioned lofts in downtown Little Rock",
      "category": "Amenity",
      "h1_title": "Air Conditioned Lofts in Downtown Little Rock",
      "h2_subtitle": "Experience comfort with air conditioned lofts in Downtown Little Rock. The Park Avenue Lofts offer stylish living spaces and premium amenities.",
      "page_copy": "Step into comfort at The Park Avenue Lofts, where air conditioned lofts in Downtown Little Rock offer a perfect blend of style and practicality. Located in the bustling area of Briarwood, residents find themselves surrounded by the vibrant energy of Little Rock, AR.\n\nThe Park Avenue Lofts provide much more than just air conditioning. Indulge in modern amenities such as hardwood floors, convenient in-unit washers and dryers, and access to a Starbucks WiFi café. Whether you're lounging at the poolside cabana or warming up by the gas fire pit, our lofts ensure a temperature-controlled haven in the heart of Pulaski County. Schedule a tour today and find your cool, new home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019d0784-2fac-7706-9699-aa37df615a58.webp",
      "featured_image_media": {
        "alt_text": "Dining area and kitchen with island seating and modern decor.",
        "public_id": "019d0784-2fac-7706-9699-aa37df615a58",
        "storage_key": "property/6737460151192619/019d0784-2fac-7706-9699-aa37df615a58.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Lofts in Downtown Little Rock",
      "seo_description": "Discover air conditioned lofts at The Park Avenue Lofts in Downtown Little Rock. Modern living with cooling comfort, schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "page_item_url": "apartments-stainless-steel-appliances-72205",
      "search_query": "apartments with stainless steel appliances 72205",
      "category": "Amenity",
      "h1_title": "Apartments with Stainless Steel Appliances 72205",
      "h2_subtitle": "Explore apartments with stainless steel appliances in the 72205 zip code. Enjoy modern living at The Park Avenue Lofts.",
      "page_copy": "Welcome to The Park Avenue Lofts, where modern apartments with stainless steel appliances redefine living in the 72205 zip code. Nestled in Little Rock's vibrant Briarwood neighborhood, our community offers the stylish and functional spaces you desire.\n\nBeyond these sleek appliances, residents indulge in convenient amenities like in-unit washers and dryers, hardwood floors, and a Starbucks WiFi café. Relax poolside at the cabana or enjoy quality time in our lush community areas. Experience how stainless steel complements a contemporary lifestyle at The Park Avenue Lofts. We can't wait to show you around—contact us to schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019d0784-2fac-7706-9699-aa37df615a58.webp",
      "featured_image_media": {
        "alt_text": "Dining area and kitchen with island seating and modern decor.",
        "public_id": "019d0784-2fac-7706-9699-aa37df615a58",
        "storage_key": "property/6737460151192619/019d0784-2fac-7706-9699-aa37df615a58.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Stainless Steel Appliances in 72205",
      "seo_description": "Find modern living at The Park Avenue Lofts with stainless steel appliances in the 72205 zip code. Tour our stylish apartments today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "page_item_url": "studio-apartments-briarwood-little-rock",
      "search_query": "studio apartments in Briarwood Little Rock",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Briarwood Little Rock",
      "h2_subtitle": "Discover studio apartments in Briarwood, Little Rock. Enjoy modern amenities and thriving community life at The Park Avenue Lofts.",
      "page_copy": "At The Park Avenue Lofts, our studio apartments in Briarwood, Little Rock, offer an unparalleled living experience. Nestled in this lively neighborhood, our community provides a perfect backdrop for modern, sophisticated living.\n\nResidents enjoy chic and efficient studio layouts complemented by amenities like in-unit washers and dryers, elegant hardwood floors, and a Starbucks WiFi café. The welcoming gas fire pit and cabana add a touch of community flair and relaxation. Embrace the dynamic lifestyle The Park Avenue Lofts offers in the heart of Briarwood. Contact us to schedule a tour of our studios and see for yourself!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019d0784-2fac-7706-9699-aa37df615a58.webp",
      "featured_image_media": {
        "alt_text": "Dining area and kitchen with island seating and modern decor.",
        "public_id": "019d0784-2fac-7706-9699-aa37df615a58",
        "storage_key": "property/6737460151192619/019d0784-2fac-7706-9699-aa37df615a58.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Briarwood, Little Rock",
      "seo_description": "Experience modern studio apartment living in Briarwood, Little Rock at The Park Avenue Lofts with premium amenities. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-little-rock-ar",
      "search_query": "1 bedroom apartments Little Rock AR",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Little Rock, AR",
      "h2_subtitle": "Find your ideal 1 bedroom apartment in Little Rock, AR at The Park Avenue Lofts. Enjoy modern amenities in a vibrant community.",
      "page_copy": "Discover the perfect 1 bedroom apartment at The Park Avenue Lofts in Little Rock, AR. Located in the bustling Briarwood neighborhood, our community seamlessly blends contemporary design with practical living spaces.\n\nOur residents appreciate stylish features like hardwood floors, stainless steel appliances, and in-unit washers and dryers. You can unwind in our Starbucks WiFi café or relax by the gas fire pit, creating a balanced lifestyle right at home. Experience the allure of living in a vibrant community full of beautiful one-bedroom options. Schedule a tour with us today and step into your future!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019d0784-2fac-7706-9699-aa37df615a58.webp",
      "featured_image_media": {
        "alt_text": "Dining area and kitchen with island seating and modern decor.",
        "public_id": "019d0784-2fac-7706-9699-aa37df615a58",
        "storage_key": "property/6737460151192619/019d0784-2fac-7706-9699-aa37df615a58.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Little Rock, AR",
      "seo_description": "Explore 1 bedroom apartments in Little Rock, AR at The Park Avenue Lofts. Enjoy modern design and top amenities in a vibrant location!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192619",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-pulaski-county-ar",
      "search_query": "2 bedroom apartments near Pulaski County AR",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near Pulaski County, AR",
      "h2_subtitle": "Explore spacious 2 bedroom apartments near Pulaski County, AR at The Park Avenue Lofts. Discover modern amenities and vibrant community life.",
      "page_copy": "Experience modern living at its finest with spacious 2 bedroom apartments near Pulaski County, AR. Nestled in the heart of Little Rock's Briarwood neighborhood, The Park Avenue Lofts offers stylish living spaces designed to cater to your lifestyle.\n\nThese apartments feature elegant hardwood floors, stainless steel appliances, and in-unit washers and dryers. Enjoy community amenities such as a Starbucks WiFi café, cabana, and gas fire pit. Discover a unique blend of comfort and convenience that our two-bedroom layouts provide. Reach out today to schedule a tour and explore all that The Park Avenue Lofts has to offer!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192619/019d0784-2fac-7706-9699-aa37df615a58.webp",
      "featured_image_media": {
        "alt_text": "Dining area and kitchen with island seating and modern decor.",
        "public_id": "019d0784-2fac-7706-9699-aa37df615a58",
        "storage_key": "property/6737460151192619/019d0784-2fac-7706-9699-aa37df615a58.webp",
        "width": 1920,
        "height": 1280
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near Pulaski County, AR",
      "seo_description": "Find modern 2 bedroom apartments near Pulaski County, AR at The Park Avenue Lofts. Discover a vibrant community with top amenities!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3374"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483148"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4562637"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KXQPCPP7"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_rp_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=rp"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "501-298-4527"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "501-298-4463"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_rp_title",
      "type": "STRING",
      "value": "RentPath"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "501-298-4483"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "501-298-4985"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "501-298-4524"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "501-298-4908"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "501-298-4453"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "501-298-4961"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "501-359-5456"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_knock_rp_number",
      "type": "STRING",
      "value": "501-298-4525"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "501-842-7337"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "501-298-4610"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "501-799-1484"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "501-403-0414"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "501-222-9639"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "501-322-6437"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "501-298-4513"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "501-365-8387"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "2756511724"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "501-530-9619"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "501-393-1164"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "1eede8bf86c1b431"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "501-443-4922"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "501-298-4584"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "501-530-8963"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "501-653-6714"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "501-298-4585"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "501-298-4612"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "501-298-4477"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.theparkavenuelofts.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192619/019e69a2-f1b9-758a-b363-1893399052fe.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "501-298-4891"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "501-359-5456"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3374",
  "custom_repli_id": "5028483148",
  "custom_realpage_id": "4562637",
  "custom_knock_a_link": "https://www.theparkavenuelofts.com?utm_knock=a",
  "custom_knock_g_link": "https://www.theparkavenuelofts.com?utm_knock=g",
  "custom_knock_w_link": "https://www.theparkavenuelofts.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-KXQPCPP7",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.theparkavenuelofts.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.theparkavenuelofts.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.theparkavenuelofts.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.theparkavenuelofts.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.theparkavenuelofts.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.theparkavenuelofts.com?utm_knock=gp",
  "custom_knock_rp_link": "https://www.theparkavenuelofts.com?utm_knock=rp",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "501-298-4527",
  "custom_knock_ads_link": "https://www.theparkavenuelofts.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.theparkavenuelofts.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "501-298-4463",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.theparkavenuelofts.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.theparkavenuelofts.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.theparkavenuelofts.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.theparkavenuelofts.com?utm_knock=psa",
  "custom_knock_rp_title": "RentPath",
  "custom_knock_w_number": "501-298-4483",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "501-298-4985",
  "custom_knock_amap_link": "https://www.theparkavenuelofts.com?utm_knock=amap",
  "custom_knock_ar_number": "501-298-4524",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "501-298-4908",
  "custom_knock_fb_number": "501-298-4453",
  "custom_knock_fl_number": "501-298-4961",
  "custom_knock_gp_number": "501-359-5456",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.theparkavenuelofts.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_knock_rp_number": "501-298-4525",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "501-842-7337",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.theparkavenuelofts.com?utm_knock=bcard",
  "custom_knock_bnr_number": "501-298-4610",
  "custom_knock_cfres_link": "https://www.theparkavenuelofts.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "501-799-1484",
  "custom_knock_lgp_number": "501-403-0414",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.theparkavenuelofts.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "501-222-9639",
  "custom_knock_psa_number": "501-322-6437",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "501-298-4513",
  "custom_knock_bandit_link": "https://www.theparkavenuelofts.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.theparkavenuelofts.com?utm_knock=flyers",
  "custom_knock_osoc_number": "501-365-8387",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "2756511724",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "501-530-9619",
  "custom_knock_cfres_number": "501-393-1164",
  "custom_knock_chatgpt_link": "https://www.theparkavenuelofts.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "1eede8bf86c1b431",
  "custom_knock_dirmail_link": "https://www.theparkavenuelofts.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "501-443-4922",
  "custom_knock_propbro_link": "https://www.theparkavenuelofts.com?utm_knock=propbro",
  "custom_knock_bandit_number": "501-298-4584",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "501-530-8963",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.theparkavenuelofts.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "501-653-6714",
  "custom_knock_dirmail_number": "501-298-4585",
  "custom_knock_propbro_number": "501-298-4612",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "501-298-4477",
  "custom_knock_maintenance_link": "https://www.theparkavenuelofts.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192619/019e69a2-f1b9-758a-b363-1893399052fe.mp4",
  "custom_knock_maintenance_number": "501-298-4891",
  "custom_ppc_tracking_phone_number": "501-359-5456"
};

export const generatedAt = '2026-10-07T17:14:32.329Z';
